(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2738,6796],{

/***/ 64677:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/symbol/[symbol]",
      function () {
        return __webpack_require__(70975);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 70975:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ _symbol_; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./src/global/SEO/index.tsx
var SEO = __webpack_require__(26350);
// EXTERNAL MODULE: ./src/global/StreamWidget/Post/index.tsx + 1 modules
var Post = __webpack_require__(3841);
// EXTERNAL MODULE: ./src/global/StreamWidget/styled.ts
var styled = __webpack_require__(59007);
// EXTERNAL MODULE: ./src/global/StreamWidget/EmptyState/index.tsx
var EmptyState = __webpack_require__(21776);
;// CONCATENATED MODULE: ./src/global/StreamWidget/GuestStream.tsx




/**
 * Stream Widget component
 * @param {string} props.symbol
 */ var GuestStream = function(param) {
    var _posts = param.posts, posts = _posts === void 0 ? [] : _posts, _isCompanyStock = param.isCompanyStock, isCompanyStock = _isCompanyStock === void 0 ? false : _isCompanyStock;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* StreamWidgetBox */.Vd, {
        noBorder: false,
        isCompanyStock: isCompanyStock,
        className: "guest-stream",
        children: posts.length === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(EmptyState/* default */.Z, {
            description: ""
        }) : posts.map(function(post) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Post/* default */.Z, {
                post: post,
                hasFollowingActivity: false,
                entryPoint: "stream"
            }, post.postid);
        })
    });
};
/* harmony default export */ var StreamWidget_GuestStream = (GuestStream);

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/constants/app.js
var app = __webpack_require__(86123);
// EXTERNAL MODULE: ./node_modules/@stockbit/ui/index.js
var ui = __webpack_require__(76825);
// EXTERNAL MODULE: ./src/utils/number.js
var number = __webpack_require__(62974);
// EXTERNAL MODULE: ./node_modules/numeral/numeral.js
var numeral = __webpack_require__(92077);
var numeral_default = /*#__PURE__*/__webpack_require__.n(numeral);
// EXTERNAL MODULE: ./src/utils/general.js
var general = __webpack_require__(42227);
// EXTERNAL MODULE: ./src/utils/company.ts
var company = __webpack_require__(4168);
// EXTERNAL MODULE: ./node_modules/antd/es/tooltip/index.js + 5 modules
var tooltip = __webpack_require__(36084);
// EXTERNAL MODULE: ./src/global/Notation/IndicatorBar.tsx
var IndicatorBar = __webpack_require__(52491);
// EXTERNAL MODULE: ./src/global/CorpAction/CorpActionBar.tsx
var CorpActionBar = __webpack_require__(88679);
// EXTERNAL MODULE: ./src/utils/tags.tsx + 2 modules
var tags = __webpack_require__(91601);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./src/global/CorpAction/CorpActionTag.tsx
var CorpActionTag = __webpack_require__(66988);
// EXTERNAL MODULE: ./src/global/Image/index.js
var Image = __webpack_require__(579);
// EXTERNAL MODULE: ./src/global/Notation/index.tsx
var Notation = __webpack_require__(15068);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./src/features/company/Chart/ExpandButtonToggle.tsx
var ExpandButtonToggle = __webpack_require__(68068);
;// CONCATENATED MODULE: ./src/features/company/GuestHeader/styled.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: ",
        ";\n  border: 1px solid ",
        ";\n  margin-bottom: 20px;\n  padding: 20px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: block;\n    left: -1px;\n    margin: 0;\n    padding: 0;\n    position: relative;\n    top: -1px;\n    width: calc(100% + 2px);\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 2px 8px;\n  width: 100px;\n\n  @media ",
        " {\n    padding: 4px 15px;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex-direction: column;\n\n  @media ",
        " {\n    flex-direction: row;\n  }\n\n  &.start-center {\n    align-items: flex-start;\n\n    @media ",
        " {\n      align-items: center;\n    }\n  }\n\n  &.end-center {\n    align-items: flex-end;\n\n    @media ",
        " {\n      align-items: center;\n    }\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  @media ",
        " {\n    margin-left: 5px;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-transform: lowercase;\n  word-wrap: anywhere;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  border-radius: 70px;\n  color: ",
        ";\n  display: flex;\n  margin: auto;\n  min-height: 54px;\n  min-width: 54px;\n\n  > small {\n    font-family: 'Proxima Nova', sans-serif;\n    font-size: 20px;\n    font-weight: 700;\n    line-height: 27px;\n    margin: auto;\n    text-align: center;\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n  display: inline-block;\n  font-family: "ProximaNovaBd";\n  font-size: 16px;\n  font-weight: bold;\n  margin: 0;\n  max-width: calc(100% - 30px);\n  overflow: hidden;\n  padding: 0;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n'
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: inline-block;\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border: 1px solid ",
        ";\n  border-radius: 50%;\n  display: inline-block;\n  height: 18px;\n  margin-left: 10px;\n  width: 18px;\n\n  .mobile {\n    display: block;\n\n    @media ",
        " {\n      display: none;\n    }\n  }\n\n  .desktop {\n    display: none;\n\n    @media ",
        " {\n      display: block;\n    }\n  }\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-radius: 2px;\n  display: inline-block;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: normal;\n  position: relative;\n  top: -3px;\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  border: solid 1px rgba(238, 74, 73, 0.5);\n  border-radius: 2px;\n  color: ",
        ";\n  display: inline-block;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: normal;\n  margin-left: 8px;\n  padding: 0px 5px;\n  position: relative;\n  top: -5px;\n  vertical-align: middle;\n\n  > span {\n    font-style: normal;\n  }\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: 5px;\n\n  > h1 {\n    color: ",
        ';\n    font-family: "ProximaNovaRg";\n    font-size: 14px;\n    line-height: 15px;\n    margin: 0;\n    padding: 0;\n  }\n'
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n  width: 100%;\n\n  span.catalogs {\n    display: inline-block;\n    font-family: "ProximaNovaRg";\n    font-size: 16px;\n    font-weight: 700;\n    max-width: calc(100% - 30px);\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n\n  a {\n    color: ',
        ";\n    display: block;\n    font-size: 12px;\n    font-weight: normal;\n    max-width: 100%;\n    overflow: hidden;\n    padding-right: 7px;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 0;\n  position: relative;\n\n  span {\n    border: 1px solid rgba(0, 171, 107, 0.3);\n    border-radius: 2px;\n    display: inline-block;\n    margin-bottom: 5px;\n    margin-right: 5px;\n    padding: 0 5px;\n    text-align: center;\n  }\n\n  a {\n    display: block;\n    font-weight: normal;\n    padding: 2px 0;\n  }\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n margin: 0;\n\n @media ",
        " {\n    margin: auto;\n    margin-top: 5px;\n }\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: flex-start;\n  background: ",
        ";\n  border: none;\n  display: flex;\n  flex-direction: column;\n  gap: 15px;\n  height: auto;\n  line-height: 1.15;\n  min-height: 65px;\n  padding: 17.5px 20px 12.5px;\n  position: relative;\n\n  @media ",
        " {\n    align-items: center;\n    border: 1px solid ",
        ";\n    flex-direction: row;\n    padding: 17.5px 20px 12.5px;\n  }\n"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: inline-block;\n  margin-left: 4px;\n"
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: inline-block;\n  margin-left: 4px;\n"
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: block !important;\n  position: absolute;\n  top: 89px;\n  right: 20px;\n\n  @media ",
        " {\n    display: none !important;\n    position: relative;\n  }\n"
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      background-color: ",
        ";\n      flex-direction: column;\n      \n      > a {\n        width: 100%;\n      }\n\n      @media ",
        " {\n        border-left: 1px solid ",
        ";\n        border-right: 1px solid ",
        ";\n        flex-direction: row;\n\n        > div {\n          flex-basis: ",
        ";\n        }\n\n        > a {\n          flex-basis: ",
        ";\n        } \n      }\n    "
    ]);
    _templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      background-color: transparent;\n    "
    ]);
    _templateObject22 = function _templateObject22() {
        return data;
    };
    return data;
}
function _templateObject23() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject23 = function _templateObject23() {
        return data;
    };
    return data;
}






var Button = ui/* Common.Button */.Gn.Button, Flex = ui/* Common.Flex */.Gn.Flex, Text = ui/* Common.Text */.Gn.Text;
var Header = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-b139ce5c-0"
})(_templateObject(), ui/* color.light */.$_.light, ui/* color.gainsboro */.$_.gainsboro);
var CompanyHeader = styled_components_browser_esm["default"].section.withConfig({
    componentId: "sc-b139ce5c-1"
})(_templateObject1());
// eslint-disable-next-line space-infix-ops
var CountryFlag = (0,styled_components_browser_esm["default"])(Image/* default */.Z).withConfig({
    componentId: "sc-b139ce5c-2"
})(_templateObject2());
var ButtonFollow = (0,styled_components_browser_esm["default"])(Button).withConfig({
    componentId: "sc-b139ce5c-3"
})(_templateObject3(), ui/* device.tablet */.Uh.tablet);
var ColumnMobile = (0,styled_components_browser_esm["default"])(Flex).withConfig({
    componentId: "sc-b139ce5c-4"
})(_templateObject4(), ui/* device.tablet */.Uh.tablet, ui/* device.tablet */.Uh.tablet, ui/* device.tablet */.Uh.tablet);
var Percentage = (0,styled_components_browser_esm["default"])(Text).attrs({
    size: "13px",
    family: "bold"
}).withConfig({
    componentId: "sc-b139ce5c-5"
})(_templateObject5(), ui/* device.tablet */.Uh.tablet);
var Value = (0,styled_components_browser_esm["default"])(Text).attrs({
    size: "18px",
    color: ui/* color.black */.$_.black,
    family: "bold"
}).withConfig({
    componentId: "sc-b139ce5c-6"
})(_templateObject6());
var IMAGE_PLACEHOLDER_COLOR = "#3A645C";
var ImagePlaceholder = styled_components_browser_esm["default"].span.withConfig({
    componentId: "sc-b139ce5c-7"
})(_templateObject7(), IMAGE_PLACEHOLDER_COLOR, ui/* color.light */.$_.light);
var Symbol = styled_components_browser_esm["default"].h3.withConfig({
    componentId: "sc-b139ce5c-8"
})(_templateObject8());
var NotationCountryFlagContainer = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-b139ce5c-9"
})(_templateObject9());
var CountryFlagContainer = styled_components_browser_esm["default"].span.withConfig({
    componentId: "sc-b139ce5c-10"
})(_templateObject10(), ui/* color.veryLightGrey */.$_.veryLightGrey, ui/* device.tablet */.Uh.tablet, ui/* device.tablet */.Uh.tablet);
var NotationContainer = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-b139ce5c-11"
})(_templateObject11());
var Badges = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-b139ce5c-12"
})(_templateObject12(), ui/* color.light */.$_.light, ui/* color.sunsetOrange */.$_.sunsetOrange);
var CompanyName = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-b139ce5c-13"
})(_templateObject13(), ui/* color.highgray */.$_.highgray);
var CompanyNameContainer = styled_components_browser_esm["default"].section.withConfig({
    componentId: "sc-b139ce5c-14"
})(_templateObject14(), ui/* color.primary */.$_.primary);
var CompanyTags = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-b139ce5c-15"
})(_templateObject15());
var ImageWrapper = (0,styled_components_browser_esm["default"])(Flex).withConfig({
    componentId: "sc-b139ce5c-16"
})(_templateObject16(), ui/* device.tablet */.Uh.tablet);
var CompanyInfoWrapper = (0,styled_components_browser_esm["default"])(Flex).withConfig({
    componentId: "sc-b139ce5c-17"
})(_templateObject17(), ui/* color.light */.$_.light, ui/* device.tablet */.Uh.tablet, ui/* color.gainsboro */.$_.gainsboro);
var NewNotationTag = (0,styled_components_browser_esm["default"])(Notation/* default */.Z).withConfig({
    componentId: "sc-b139ce5c-18"
})(_templateObject18());
var NewCorpActionTag = (0,styled_components_browser_esm["default"])(CorpActionTag/* default */.Z).withConfig({
    componentId: "sc-b139ce5c-19"
})(_templateObject19());
var ExpandButtonToggleMobile = (0,styled_components_browser_esm["default"])(ExpandButtonToggle/* default */.Z).withConfig({
    componentId: "sc-b139ce5c-20"
})(_templateObject20(), ui/* device.tablet */.Uh.tablet);
var NotationCorpActionBarWrapper = (0,styled_components_browser_esm["default"])(Flex).withConfig({
    componentId: "sc-b139ce5c-21"
})(_templateObject23(), function(param) {
    var isCompanyStock = param.isCompanyStock, isBoth = param.isBoth;
    return isCompanyStock ? (0,styled_components_browser_esm.css)(_templateObject21(), ui/* color.light */.$_.light, ui/* device.tablet */.Uh.tablet, ui/* color.gainsboro */.$_.gainsboro, ui/* color.gainsboro */.$_.gainsboro, isBoth ? "50%" : "auto", isBoth ? "50%" : "auto") : (0,styled_components_browser_esm.css)(_templateObject22());
});

;// CONCATENATED MODULE: ./src/features/company/GuestHeader/index.tsx













var cleanSymbol = company/* default.cleanSymbol */.Z.cleanSymbol;
var GuestHeader_Flex = ui/* Common.Flex */.Gn.Flex, GuestHeader_Text = ui/* Common.Text */.Gn.Text;
var SymbolTag = ui/* Company.TagCompany.SymbolTag */.YD.TagCompany.SymbolTag;
var STATUS_LIST = {
    SUSPENDED: "STATUS_SUSPENDED",
    DELISTED: "STATUS_DELISTED"
};
var COMPANY_TYPE_STOCK = "saham";
function GuestHeader(param) {
    var _symbol = param.symbol, symbol = _symbol === void 0 ? "" : _symbol, company = param.company, onClickLink = param.onClickLink;
    var name = company.name, sector = company.sector, volume = company.volume, average = company.average, price = company.price, change = company.change, percentage = company.percentage, time = company.time, followers = company.followers, icon_url = company.icon_url, _country = company.country, country = _country === void 0 ? "ID" : _country, _notation = company.notation, notation = _notation === void 0 ? [] : _notation, uma = company.uma, _corp_action = company.corp_action, corp_action = _corp_action === void 0 ? {} : _corp_action, status = company.status, _catalogs = company.catalogs, catalogs = _catalogs === void 0 ? [] : _catalogs, exchange = company.exchange, _type_company = company.type_company, type_company = _type_company === void 0 ? "" : _type_company;
    var ref = (0,react.useState)(!!icon_url), isIconAvailable = ref[0], setIsIconAvailable = ref[1];
    var isNotationAvailable = !!notation.length;
    var isCorpActionAvailable = corp_action === null || corp_action === void 0 ? void 0 : corp_action.active;
    var isSuspended = status === STATUS_LIST.SUSPENDED;
    var isDelisted = status === STATUS_LIST.DELISTED;
    var isCompanyStock = (type_company === null || type_company === void 0 ? void 0 : type_company.toLowerCase()) === COMPANY_TYPE_STOCK;
    var POPUP_COUNTRY_FLAG_TEXT = "This stock is traded on ".concat(exchange, " exchange");
    var onImgError = function() {
        setIsIconAvailable(false);
    };
    var formattedCountry = country.toLowerCase();
    var IMAGE_URL = "/img/flags/".concat(formattedCountry, ".png");
    var getSectorURL = function(sector, subsector) {
        return !sector ? "" : sector && sector.toLowerCase() !== "indeks" ? "/catalog/".concat((0,general/* convertToSlug */.k6)(sector), "/").concat((0,general/* convertToSlug */.k6)(subsector)) : "/catalog/".concat((0,general/* convertToSlug */.k6)(subsector));
    };
    var onClickCatalogsLink = function(event) {
        event.preventDefault();
        onClickLink();
    };
    var renderCatalogsLink = function(catalogue) {
        var subSectorObject = {
            "Properti & Real Estate": "Properti dan Real Estate",
            Commodities: "Commodity"
        };
        var companySymbol = catalogue.catalog_name || catalogue.company_symbol;
        var companySymbolAlias = subSectorObject[companySymbol] || catalogue.company_symbol;
        var companyType = catalogue.company_type;
        if (companyType === "sub_sector") {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: getSectorURL(sector, companySymbolAlias),
                passHref: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    target: "_blank",
                    rel: "noopener noreferrer",
                    onClick: onClickCatalogsLink,
                    children: companySymbol
                })
            });
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
            href: "/catalog/".concat(companyType, "/").concat(companySymbolAlias),
            passHref: true,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                target: "_blank",
                rel: "noopener noreferrer",
                onClick: onClickCatalogsLink,
                children: companySymbol
            })
        });
    };
    var renderSymbol = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Symbol, {
            children: cleanSymbol(symbol.toUpperCase())
        });
    };
    var renderCompanyLogo = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageWrapper, {
            align: "center",
            children: isIconAvailable ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                className: "company-header-icon",
                src: icon_url,
                onError: onImgError,
                alt: symbol,
                width: "54px",
                height: "54px"
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ImagePlaceholder, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("small", {
                    children: !!symbol && symbol.toUpperCase().slice(0, 1)
                })
            })
        });
    };
    var renderNotationCorpActionBadges = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(NotationContainer, {
            children: (0,tags/* renderTags */.a)({
                symbol: symbol,
                uma: uma,
                notation: notation,
                corp_action: corp_action
            })
        });
    };
    var renderCountryFlag = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CountryFlagContainer, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CountryFlag, {
                    className: "mobile",
                    src: IMAGE_URL,
                    alt: "".concat(country, " flag")
                }, "country-flag-mobile"),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(tooltip/* default */.Z, {
                    className: "desktop",
                    placement: "top",
                    title: POPUP_COUNTRY_FLAG_TEXT,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CountryFlag, {
                        src: IMAGE_URL,
                        alt: "".concat(country, " flag")
                    }, "country-flag-desktop")
                })
            ]
        });
    };
    var renderSuspendedDelistedBadges = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                isSuspended && /*#__PURE__*/ (0,jsx_runtime.jsx)(Badges, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: "Suspended"
                    })
                }),
                isDelisted && /*#__PURE__*/ (0,jsx_runtime.jsx)(Badges, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: "Delisted"
                    })
                })
            ]
        });
    };
    var renderCompanyName = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyName, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                children: name
            })
        });
    };
    var renderCompanyTags = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyTags, {
            children: catalogs.slice(0, 6).map(function(catalogue) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "catalogs",
                    children: renderCatalogsLink(catalogue)
                }, catalogue.company_symbol);
            })
        });
    };
    var renderExpandButtonToggle = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ExpandButtonToggleMobile, {
            onExpand: onClickCatalogsLink
        });
    };
    var renderNotationCorpActionBar = function(isCompanyStock) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(NotationCorpActionBarWrapper, {
            isCompanyStock: isCompanyStock,
            isBoth: isNotationAvailable && isCorpActionAvailable,
            children: [
                isNotationAvailable && /*#__PURE__*/ (0,jsx_runtime.jsx)(IndicatorBar/* default */.Z, {
                    symbol: symbol,
                    notation: notation,
                    uma: uma,
                    name: name,
                    isGuestCompanyStock: isCompanyStock,
                    onClick: onClickCatalogsLink
                }),
                isCorpActionAvailable && /*#__PURE__*/ (0,jsx_runtime.jsx)(CorpActionBar/* default */.Z, {
                    symbol: symbol,
                    corpAction: corp_action,
                    isGuestCompanyStock: isCompanyStock,
                    onClick: onClickCatalogsLink
                })
            ]
        });
    };
    var renderNonCompanyHeader = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Header, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(GuestHeader_Flex, {
                    align: "center",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SymbolTag, {
                        children: symbol.toUpperCase()
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(GuestHeader_Flex, {
                    justify: "space-between",
                    mt: "10px",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(ColumnMobile, {
                            className: "start-center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(GuestHeader_Text, {
                                    size: "24px",
                                    family: "bold",
                                    mr: "10px",
                                    style: {
                                        flex: 1
                                    },
                                    children: name
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(GuestHeader_Text, {
                                    color: ui/* color.primary */.$_.primary,
                                    size: "14px",
                                    mr: "10px",
                                    children: sector
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: "/register",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonFollow, {
                                height: "30px",
                                as: "a",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(GuestHeader_Text, {
                                    padding: "0 0 0 5px",
                                    color: ui/* color.dimgray */.$_.dimgray,
                                    family: "bold",
                                    children: "Follow"
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(GuestHeader_Flex, {
                    align: "center",
                    mt: "20px",
                    mb: "20px",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(GuestHeader_Flex, {
                            as: "div",
                            direction: "column",
                            mr: "20px",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(ColumnMobile, {
                                    className: "start-center",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Value, {
                                            children: numeral_default()(price).format("0,0.00")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Percentage, {
                                            color: change > 0 ? ui/* color.primary */.$_.primary : ui/* color.sunsetOrange */.$_.sunsetOrange,
                                            children: [
                                                change > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                    children: "▴"
                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                    children: "▾"
                                                }),
                                                " ",
                                                numeral_default()(change || 0).format("0,0.00"),
                                                " (",
                                                percentage,
                                                ")"
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(GuestHeader_Text, {
                                    size: "13px",
                                    color: ui/* color.midgray */.$_.midgray,
                                    mt: "4px",
                                    children: [
                                        "As of ",
                                        time
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(GuestHeader_Flex, {
                            as: "div",
                            direction: "column",
                            mr: "20px",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Value, {
                                    children: number/* default.kNumberFormatter */.ZP.kNumberFormatter(volume, 2, true, true)
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(GuestHeader_Text, {
                                    size: "13px",
                                    color: ui/* color.midgray */.$_.midgray,
                                    mt: "4px",
                                    children: "Volume"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(GuestHeader_Flex, {
                            as: "div",
                            direction: "column",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Value, {
                                    children: number/* default.kNumberFormatter */.ZP.kNumberFormatter(average, 2, true, true)
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(GuestHeader_Text, {
                                    size: "13px",
                                    color: ui/* color.midgray */.$_.midgray,
                                    mt: "4px",
                                    children: "Avg Volume"
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(GuestHeader_Text, {
                            size: "14px",
                            color: ui/* color.dimgray */.$_.dimgray,
                            family: "bold",
                            as: "span",
                            children: numeral_default()(followers || 0).format("0,0")
                        }),
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(GuestHeader_Text, {
                            size: "14px",
                            color: ui/* color.midgray */.$_.midgray,
                            as: "span",
                            children: "Followers"
                        })
                    ]
                })
            ]
        });
    };
    var renderCompanyHeader = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CompanyHeader, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(CompanyInfoWrapper, {
                    children: [
                        renderCompanyLogo(),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(CompanyNameContainer, {
                            children: [
                                renderSymbol(),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(NotationCountryFlagContainer, {
                                    children: [
                                        renderNotationCorpActionBadges(),
                                        renderCountryFlag(),
                                        renderSuspendedDelistedBadges()
                                    ]
                                }),
                                renderCompanyName(),
                                renderCompanyTags()
                            ]
                        }),
                        renderExpandButtonToggle()
                    ]
                }),
                renderNotationCorpActionBar(isCompanyStock)
            ]
        });
    };
    return isCompanyStock ? renderCompanyHeader() : renderNonCompanyHeader();
}
/* harmony default export */ var company_GuestHeader = (GuestHeader);

// EXTERNAL MODULE: ./src/features/company/styled.ts + 4 modules
var company_styled = __webpack_require__(46796);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 17 modules
var es = __webpack_require__(2497);
// EXTERNAL MODULE: ./node_modules/antd/es/row/index.js
var row = __webpack_require__(71230);
// EXTERNAL MODULE: ./node_modules/antd/es/col/index.js
var col = __webpack_require__(15746);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/antd/es/divider/index.js
var divider = __webpack_require__(27049);
;// CONCATENATED MODULE: ./src/features/company/GuestRegisterModal/styled.ts

function styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 20px;\n  @media (min-width: 600px) {\n    border-radius: 6px;\n  }\n  @media ",
        " {\n    &.left-content img {\n      width: 400px;\n    }\n  }\n"
    ]);
    styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  @media (min-width: 600px) {\n    padding: 17% 10% 0 10%;\n  }\n  @media ",
        " {\n    padding: 20% 10% 0 10%;\n  }\n"
    ]);
    styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  position: absolute;\n  text-align: center;\n  top: 30px;\n  left: 50%;\n  transform: translate3d(-50%, 0, 0);\n  div.title-banner {\n    color: #066c46;\n    font-size: 20px;\n    margin-bottom: 8px;\n    font-family: ProximaNovaBd;\n  }\n  p {\n    color: #066c46;\n    font-size: 13px;\n    margin-bottom: 0;\n  }\n\n  @media (min-width: 600px) {\n    top: 76px;\n    div.title-banner {\n      font-size: 19.6px;\n    }\n    p {\n      font-size: 11.2px;\n    }\n  }\n\n  @media ",
        " {\n    top: 109px;\n    div.title-banner {\n      font-size: 28px;\n    }\n    p {\n      font-size: 16px;\n    }\n  }\n"
    ]);
    styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  @media (min-width: 600px) {\n    font-size: 9.8px;\n  }\n  @media ",
        " {\n    font-size: 14px;\n  }\n"
    ]);
    styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function styled_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 5%;\n  border-top: 1px solid ",
        ";\n"
    ]);
    styled_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function styled_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 100%;\n"
    ]);
    styled_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function styled_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  img {\n    width: 66.51px;\n    height: 25.7px;\n  }\n  @media ",
        " {\n    img {\n      width: 95.02px;\n      height: 36.72px;\n    }\n  }\n"
    ]);
    styled_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function styled_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 0;\n  font-size: 19.6px;\n  font-family: ProximaNovaBd;\n  @media ",
        " {\n    font-size: 28px;\n  }\n"
    ]);
    styled_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function styled_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 10% 0 !important;\n  padding: 0 30px !important;\n"
    ]);
    styled_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function styled_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  border-top: 1px solid ",
        ";\n"
    ]);
    styled_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}



var Modal = ui/* Common.Modal */.Gn.Modal, styled_Flex = ui/* Common.Flex */.Gn.Flex, styled_Text = ui/* Common.Text */.Gn.Text;
var RegisterModal = (0,styled_components_browser_esm["default"])(Modal).withConfig({
    componentId: "sc-46a5e970-0"
})(styled_templateObject(), ui/* device.laptop */.Uh.laptop);
var Container = (0,styled_components_browser_esm["default"])(col/* default */.Z).withConfig({
    componentId: "sc-46a5e970-1"
})(styled_templateObject1(), ui/* device.laptop */.Uh.laptop);
var TitleBanner = (0,styled_components_browser_esm["default"])(col/* default */.Z).withConfig({
    componentId: "sc-46a5e970-2"
})(styled_templateObject2(), ui/* device.laptop */.Uh.laptop);
var CustomText = (0,styled_components_browser_esm["default"])(styled_Text).withConfig({
    componentId: "sc-46a5e970-3"
})(styled_templateObject3(), ui/* device.laptop */.Uh.laptop);
var ColEmailButton = (0,styled_components_browser_esm["default"])(col/* default */.Z).withConfig({
    componentId: "sc-46a5e970-4"
})(styled_templateObject4(), ui/* color.downgray */.$_.downgray);
var RowRegisterForm = (0,styled_components_browser_esm["default"])(row/* default */.Z).withConfig({
    componentId: "sc-46a5e970-5"
})(styled_templateObject5());
var LogoContainer = (0,styled_components_browser_esm["default"])(styled_Flex).withConfig({
    componentId: "sc-46a5e970-6"
})(styled_templateObject6(), ui/* device.laptop */.Uh.laptop);
var TitleForm = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-46a5e970-7"
})(styled_templateObject7(), ui/* device.laptop */.Uh.laptop);
var DividerText = (0,styled_components_browser_esm["default"])(divider/* default */.Z).withConfig({
    componentId: "sc-46a5e970-8"
})(styled_templateObject8());
var Footer = (0,styled_components_browser_esm["default"])(styled_Flex).withConfig({
    componentId: "sc-46a5e970-9"
})(styled_templateObject9(), ui/* color.downgray */.$_.downgray);


// EXTERNAL MODULE: ./src/features/register/GoogleOauth/index.tsx
var GoogleOauth = __webpack_require__(79106);
// EXTERNAL MODULE: ./src/features/register/FacebookOauth/index.tsx
var FacebookOauth = __webpack_require__(72099);
// EXTERNAL MODULE: ./src/features/register/slice.ts
var slice = __webpack_require__(7952);
// EXTERNAL MODULE: ./src/features/register/constants.ts
var constants = __webpack_require__(28456);
;// CONCATENATED MODULE: ./src/features/company/GuestRegisterModal/index.tsx














var GuestRegisterModal_Modal = ui/* Common.Modal */.Gn.Modal, GuestRegisterModal_Text = ui/* Common.Text */.Gn.Text, Iconmoon = ui/* Common.Iconmoon */.Gn.Iconmoon, GuestRegisterModal_Flex = ui/* Common.Flex */.Gn.Flex, GuestRegisterModal_Button = ui/* Common.Button */.Gn.Button;
var getWindowSize = function() {
    if (false) {}
    var _documentElement = document.documentElement, width = _documentElement.clientWidth, height = _documentElement.clientHeight;
    return {
        width: width,
        height: height
    };
};
var GuestRegisterModal = function(param) {
    var isCompanyStock = param.isCompanyStock, visible = param.visible, setVisible = param.setVisible, features = param.features;
    var dispatch = (0,es/* useDispatch */.I0)();
    var router = (0,next_router.useRouter)();
    var ref = (0,react.useState)(getWindowSize()), windowSize = ref[0], setWindowSize = ref[1];
    var isMobileView = windowSize.width < 600;
    var isTabletView = windowSize.width >= 600 && windowSize.width < 1024;
    var isLaptopView = windowSize.width >= 1024;
    var bannerWidth = isLaptopView ? 450 : 315;
    (0,react.useEffect)(function() {
        var handleWindowResize = function handleWindowResize() {
            setWindowSize(getWindowSize());
        };
        window.addEventListener("resize", handleWindowResize);
        return function() {
            window.removeEventListener("resize", handleWindowResize);
        };
    }, []);
    var navigate = function() {
        if (!isMobileView) {
            dispatch(slice/* default.actions.changeForm */.ZP.actions.changeForm({
                target: constants/* formTypes.EMAIL */.o_.EMAIL
            }));
        }
        router.push("/register");
    };
    var renderNonStockModal = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(GuestRegisterModal_Modal, {
            type: "basic",
            visible: visible,
            onCancel: function() {
                return setVisible(!visible);
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                style: {
                    padding: 30
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(GuestRegisterModal_Text, {
                        as: "span",
                        family: "bold",
                        size: "36px",
                        children: [
                            "Daftar",
                            " "
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(GuestRegisterModal_Text, {
                        as: "span",
                        family: "bold",
                        size: "36px",
                        color: ui/* color.primary */.$_.primary,
                        children: "Gratis"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(GuestRegisterModal_Text, {
                        as: "p",
                        family: "bold",
                        size: "18px",
                        children: "dan dapatkan:"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(GuestRegisterModal_Flex, {
                        direction: "column",
                        mt: "30px",
                        mb: "30px",
                        children: [
                            features.map(function(f) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(GuestRegisterModal_Flex, {
                                    align: "center",
                                    padding: "6px 0",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconmoon, {
                                            className: f.icon,
                                            size: "24px",
                                            color: ui/* color.black */.$_.black
                                        }, f.name),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(GuestRegisterModal_Text, {
                                            padding: "0 0 0 10px",
                                            size: "18px",
                                            children: f.name
                                        })
                                    ]
                                });
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(GuestRegisterModal_Text, {
                                color: ui/* color.midgray */.$_.midgray,
                                size: "10px",
                                mt: "5px",
                                children: "*) Gratis Coba 30 Hari"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: "/register",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(company_styled/* RegisterButton */.DT, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(GuestRegisterModal_Text, {
                                color: ui/* color.light */.$_.light,
                                size: "20px",
                                family: "bold",
                                children: "Daftar Sekarang"
                            })
                        })
                    })
                ]
            })
        });
    };
    var renderStockModal = function() {
        var imageBanner = isLaptopView ? "/images/pc-guest-banner.jpg" : isTabletView ? "/images/tablet-guest-banner.jpg" : "/images/mobile-guest-banner.jpg";
        var registerButtonText = isMobileView ? "Daftar Sekarang" : "Register with Email";
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(RegisterModal, {
            centered: true,
            type: "basic",
            width: "100%",
            style: {
                maxWidth: isMobileView ? bannerWidth : bannerWidth * 2,
                paddingBottom: 0
            },
            visible: visible,
            onCancel: function() {
                return setVisible(!visible);
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(row/* default */.Z, {
                justify: "space-between",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(col/* default */.Z, {
                        span: isMobileView ? 24 : 12,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TitleBanner, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "title-banner",
                                        children: "Daftar Stockbit Sekarang"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: "Gabung Komunitas Saham dan Dapatkan"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        children: [
                                            "Berbagai ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                                children: "Fitur Pro GRATIS"
                                            }),
                                            " Selama 30 Hari! \uD83D\uDE80"
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                alt: "Register Sotckbit",
                                src: imageBanner,
                                style: {
                                    width: bannerWidth
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ColEmailButton, {
                                span: isMobileView ? 24 : 0,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(GuestRegisterModal_Button, {
                                    block: true,
                                    round: true,
                                    type: "primary",
                                    onClick: navigate,
                                    height: "44px",
                                    id: "email-register",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomText, {
                                        color: "light",
                                        family: "bold",
                                        children: registerButtonText
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                        span: isMobileView ? 0 : 12,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(RowRegisterForm, {
                            justify: "space-between",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, {
                                    span: 24,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(LogoContainer, {
                                            align: "center",
                                            justify: "center",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                                src: "/icon/stockbit-new.svg",
                                                alt: "Sotckbit"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(GuestRegisterModal_Flex, {
                                            align: "center",
                                            justify: "center",
                                            margin: "10% 0 8% 0",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TitleForm, {
                                                children: "Welcome to Stockbit"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(GoogleOauth/* default */.Z, {
                                            isCompanyStock: true,
                                            variant: "secondary",
                                            size: isLaptopView ? "large" : "medium"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FacebookOauth/* default */.Z, {
                                            isCompanyStock: true,
                                            variant: "secondary",
                                            size: isLaptopView ? "large" : "medium"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(DividerText, {
                                            plain: true,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomText, {
                                                color: "#B5B5B5",
                                                family: "bold",
                                                children: "Or"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(GuestRegisterModal_Button, {
                                            block: true,
                                            round: true,
                                            mb: "10%",
                                            type: "primary",
                                            onClick: navigate,
                                            height: "".concat(isLaptopView ? 35 : 30.8, "px"),
                                            id: "email-register",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomText, {
                                                color: "light",
                                                family: "bold",
                                                children: registerButtonText
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(CustomText, {
                                            align: "center",
                                            children: [
                                                "Already have a Stockbit account?",
                                                " ",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                    href: "/login",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomText, {
                                                        as: "a",
                                                        family: "bold",
                                                        children: "Login"
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(GuestRegisterModal_Flex, {
                                        align: "center",
                                        justify: "center",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CustomText, {
                                            align: "center",
                                            children: [
                                                "By signing up you agree with our",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                    href: "/terms",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomText, {
                                                        as: "a",
                                                        children: " Terms & Conditions."
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        });
    };
    if (isCompanyStock) {
        return renderStockModal();
    } else {
        return renderNonStockModal();
    }
};
/* harmony default export */ var company_GuestRegisterModal = (GuestRegisterModal);

// EXTERNAL MODULE: ./src/features/company/constants.ts
var company_constants = __webpack_require__(55564);
// EXTERNAL MODULE: ./src/features/company/Chart/index.tsx + 3 modules
var Chart = __webpack_require__(82495);
;// CONCATENATED MODULE: ./src/features/company/GuestCompany.tsx











var features = [
    {
        name: "Bandar Detector",
        icon: "icon-feature_bandar"
    },
    {
        name: "Foreign Flow Chart",
        icon: "icon-feature_foreign"
    },
    {
        name: "Valuation Tool",
        icon: "icon-feature_valuation"
    },
    {
        name: "Stock Screener",
        icon: "icon-feature_screener"
    },
    {
        name: "Price-Alert",
        icon: "icon-feature_pricealert"
    },
    {
        name: "Real-time Charting Platform",
        icon: "icon-feature_charting"
    }, 
];
var CompanyGuestStream = function(param) {
    var symbol = param.symbol, posts = param.posts, company = param.company, isCompanyStock = param.isCompanyStock, companyProfile = param.companyProfile, chart = param.chart;
    var DEFAULT_VISIBLE_STATE = !isCompanyStock;
    var ref = (0,react.useState)(DEFAULT_VISIBLE_STATE), visible = ref[0], setVisible = ref[1];
    var _tabs = company.tabs, tabs = _tabs === void 0 ? [] : _tabs, name = company.name;
    var metaTitle = isCompanyStock ? "Saham: ".concat(symbol.toUpperCase(), " - PT. ").concat(name, " | Stockbit") : "Saham ".concat(symbol.toUpperCase(), " (").concat(name, ") | Stockbit");
    var metaDescription = isCompanyStock ? "Informasi detail tentang saham ".concat(symbol.toUpperCase(), " - PT. ").concat(name, " hari ini, mulai dari harga, grafik, data historis dan profil lengkap lainnya.") : "Lihat berita, harga saham, data fundamental, teknikal analisis dan laporan keuangan saham ".concat(symbol.toUpperCase(), " (").concat(name, ") Investasi, Nabung, Beli atau Jual sahamnya secara online dengan mudah.");
    var generateSchemaJson = function() {
        var companyName = company.name, exchange = company.exchange;
        return {
            "@context": "https://schema.org",
            "@type": "Article",
            mainEntityOfPage: {
                "@type": "WebPage",
                "@id": "https://stockbit.com/symbol/".concat(symbol)
            },
            headline: "Saham ".concat(symbol, " - PT. ").concat(companyName, " | Stockbit"),
            image: "",
            author: {
                "@type": "Organization",
                name: "Stockbit",
                url: "https://stockbit.com"
            },
            mentions: [
                {
                    "@type": "Corporation",
                    Legalname: "PT. ".concat(companyName),
                    tickerSymbol: "".concat(exchange, ":").concat(symbol),
                    url: "https://stockbit.com/symbol/".concat(symbol)
                }, 
            ],
            description: "Informasi detail tentang saham ".concat(symbol, " - PT. ").concat(companyName, " hari ini, mulai dari harga, grafik, data historis dan profil lengkap lainnya.")
        };
    };
    var generateMetaKeywords = function() {
        var symbolKeywords = "".concat(symbol, ", saham ").concat(symbol, ", ").concat(symbol, " saham, idx ").concat(symbol, ", ").concat(symbol, " idx, harga saham ").concat(symbol, ", harga saham ").concat(symbol, " hari ini, saham ").concat(symbol, " hari ini, ").concat(symbol, " saham hari ini, laporan keuangan ").concat(symbol, ", grafik saham ").concat(symbol, ", dividen ").concat(symbol, ", ").concat(symbol, " stock, ").concat(symbol, " hari ini, ").concat(symbol, " saham apa, analisa saham ").concat(symbol, ", saham ").concat(symbol, " bergerak di bidang apa, berita saham ").concat(symbol, ", saham ").concat(symbol, " chart, pemegang saham ").concat(symbol, ", analisis saham ").concat(symbol);
        var companyKeywords = "saham ".concat(name, ", harga saham ").concat(name, ", harga saham ").concat(name, " hari ini, ").concat(name, " saham, harga 1 lot saham ").concat(name, ", grafik saham ").concat(name, ", cara beli saham ").concat(name, ", beli saham ").concat(name, ", kode saham ").concat(name, ", saham ").concat(name, " bergerak di bidang, investasi saham ").concat(name);
        return "".concat(symbolKeywords, ", ").concat(companyKeywords);
    };
    var guestCompanyTabs = tabs.filter(function(value) {
        return value !== company_constants/* TAB_LIST_NAME.NEWS */.p.NEWS;
    }).map(function(value) {
        var newValue = value;
        if (value === company_constants/* TAB_ANALYST_NEW_NAME */.K1) {
            newValue = company_constants/* TAB_LIST_NAME.ANALYST */.p.ANALYST;
        }
        return company_constants/* TAB_LIST */.YS[newValue];
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SEO/* default */.Z, {
                title: metaTitle,
                description: metaDescription,
                keywords: isCompanyStock ? generateMetaKeywords() : undefined,
                schemaJson: isCompanyStock ? generateSchemaJson() : null
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                style: {
                    width: "100%"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(company_GuestHeader, {
                        symbol: symbol,
                        company: company,
                        onClickLink: function() {
                            return setVisible(true);
                        }
                    }),
                    isCompanyStock && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(company_styled/* GuestChartWrapper */.uf, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Chart/* default */.Z, {
                                    symbol: symbol,
                                    company: company,
                                    chart: chart,
                                    onSelectTimeFrame: function() {
                                        return setVisible(true);
                                    },
                                    onExpand: function() {
                                        return setVisible(true);
                                    },
                                    onClickChart: function() {
                                        return setVisible(true);
                                    },
                                    isChartVisible: true,
                                    timeframe: "today",
                                    disableChartbitLink: true
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(company_styled/* CustomGuestCompanyBackground */.zj, {
                                companyProfile: companyProfile,
                                onClickReadMore: setVisible
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(company_styled/* GuestNavbar */.rT, {
                        tabs: guestCompanyTabs,
                        active: company_constants/* TAB_LIST_NAME.STREAM */.p.STREAM,
                        isCompanyStock: isCompanyStock,
                        onClickTab: function() {
                            return setVisible(true);
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(company_styled/* GuestStreamWrapper */.Y5, {
                        isCompanyStock: isCompanyStock,
                        justify: "space-between",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StreamWidget_GuestStream, {
                                posts: posts,
                                isCompanyStock: isCompanyStock
                            }),
                            !isCompanyStock && /*#__PURE__*/ (0,jsx_runtime.jsx)(company_styled/* Banner */.jL, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: "/register",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            src: "".concat(app/* assetPrefix */.Vc, "/images/sekuritas-banner-right.svg"),
                                            alt: "Daftar"
                                        })
                                    })
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(company_GuestRegisterModal, {
                isCompanyStock: isCompanyStock,
                visible: visible,
                setVisible: setVisible,
                features: features
            })
        ]
    });
};
/* harmony default export */ var GuestCompany = (CompanyGuestStream);

// EXTERNAL MODULE: ./src/global/MainLayout/index.tsx + 168 modules
var MainLayout = __webpack_require__(9720);
// EXTERNAL MODULE: ./src/utils/auth.js
var auth = __webpack_require__(14229);
// EXTERNAL MODULE: ./src/lib/entities/credentials.js + 4 modules
var credentials = __webpack_require__(21671);
// EXTERNAL MODULE: ./src/global/QueryProvider/index.tsx
var QueryProvider = __webpack_require__(62780);
// EXTERNAL MODULE: ./src/features/company/FRPage/Hero/styled.ts
var Hero_styled = __webpack_require__(81676);
// EXTERNAL MODULE: ./src/features/company/FRPage/Hero/Header.tsx
var Hero_Header = __webpack_require__(35985);
// EXTERNAL MODULE: ./src/features/company/FRPage/Detail/styled.ts
var Detail_styled = __webpack_require__(59126);
// EXTERNAL MODULE: ./src/features/company/FRPage/Detail/CouponDetail.tsx
var CouponDetail = __webpack_require__(52068);
// EXTERNAL MODULE: ./src/features/company/FRPage/Detail/About.tsx
var About = __webpack_require__(15022);
// EXTERNAL MODULE: ./src/features/company/FRPage/Hero/ChartHeader.tsx + 1 modules
var ChartHeader = __webpack_require__(95186);
// EXTERNAL MODULE: ./src/features/company/Chart/styled.ts
var Chart_styled = __webpack_require__(33263);
// EXTERNAL MODULE: ./src/features/company/FRPage/Hero/MainChart.tsx + 1 modules
var MainChart = __webpack_require__(47513);
;// CONCATENATED MODULE: ./src/features/company/FRPage/GuestCompany.tsx













var GuestCompany_features = [
    {
        name: "Bandar Detector",
        icon: "icon-feature_bandar"
    },
    {
        name: "Foreign Flow Chart",
        icon: "icon-feature_foreign"
    },
    {
        name: "Valuation Tool",
        icon: "icon-feature_valuation"
    },
    {
        name: "Stock Screener",
        icon: "icon-feature_screener"
    },
    {
        name: "Price-Alert",
        icon: "icon-feature_pricealert"
    },
    {
        name: "Real-time Charting Platform",
        icon: "icon-feature_charting"
    }, 
];
var GuestFRCompany = function(param) {
    var symbol = param.symbol, company = param.company, chart = param.chart, finItem = param.finItem;
    var ref = (0,react.useState)(false), showModalRegis = ref[0], setShowModalRegis = ref[1];
    var name = company.name;
    var metaTitle = "Saham: ".concat(symbol.toUpperCase(), " - PT. ").concat(name, " | Stockbit");
    var metaDescription = "Informasi detail tentang saham ".concat(symbol.toUpperCase(), " - PT. ").concat(name, " hari ini, mulai dari harga, grafik, data historis dan profil lengkap lainnya.");
    var generateSchemaJson = function() {
        var companyName = company.name, exchange = company.exchange;
        return {
            "@context": "https://schema.org",
            "@type": "Article",
            mainEntityOfPage: {
                "@type": "WebPage",
                "@id": "https://stockbit.com/symbol/".concat(symbol)
            },
            headline: "Saham ".concat(symbol, " - PT. ").concat(companyName, " | Stockbit"),
            image: "",
            author: {
                "@type": "Organization",
                name: "Stockbit",
                url: "https://stockbit.com"
            },
            mentions: [
                {
                    "@type": "Corporation",
                    Legalname: "PT. ".concat(companyName),
                    tickerSymbol: "".concat(exchange, ":").concat(symbol),
                    url: "https://stockbit.com/symbol/".concat(symbol)
                }, 
            ],
            description: "Informasi detail tentang saham ".concat(symbol, " - PT. ").concat(companyName, " hari ini, mulai dari harga, grafik, data historis dan profil lengkap lainnya.")
        };
    };
    var generateMetaKeywords = function() {
        var symbolKeywords = "".concat(symbol, ", saham ").concat(symbol, ", ").concat(symbol, " saham, idx ").concat(symbol, ", ").concat(symbol, " idx, harga saham ").concat(symbol, ", harga saham ").concat(symbol, " hari ini, saham ").concat(symbol, " hari ini, ").concat(symbol, " saham hari ini, laporan keuangan ").concat(symbol, ", grafik saham ").concat(symbol, ", dividen ").concat(symbol, ", ").concat(symbol, " stock, ").concat(symbol, " hari ini, ").concat(symbol, " saham apa, analisa saham ").concat(symbol, ", saham ").concat(symbol, " bergerak di bidang apa, berita saham ").concat(symbol, ", saham ").concat(symbol, " chart, pemegang saham ").concat(symbol, ", analisis saham ").concat(symbol);
        var companyKeywords = "saham ".concat(name, ", harga saham ").concat(name, ", harga saham ").concat(name, " hari ini, ").concat(name, " saham, harga 1 lot saham ").concat(name, ", grafik saham ").concat(name, ", cara beli saham ").concat(name, ", beli saham ").concat(name, ", kode saham ").concat(name, ", saham ").concat(name, " bergerak di bidang, investasi saham ").concat(name);
        return "".concat(symbolKeywords, ", ").concat(companyKeywords);
    };
    var about = (0,react.useMemo)(function() {
        if (company) {
            return JSON.parse(company.metadata.find(function(item) {
                return item.key === "about";
            }).value);
        }
        return [];
    }, [
        company
    ]);
    var issuer = (0,react.useMemo)(function() {
        if (company) {
            return company.metadata.find(function(item) {
                return item.key === "issuer";
            }).value;
        }
        return [];
    }, [
        company
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(QueryProvider/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SEO/* default */.Z, {
                title: metaTitle,
                description: metaDescription,
                keywords: generateMetaKeywords(),
                schemaJson: generateSchemaJson()
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                style: {
                    width: "100%"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Hero_styled/* HeroWrapper */.dI, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Hero_Header/* default */.Z, {
                                symbol: symbol,
                                company: company,
                                isGuestCompany: true,
                                onClickBuyButton: function() {
                                    return setShowModalRegis(true);
                                },
                                onExpandToggle: function() {
                                    return setShowModalRegis(true);
                                },
                                onClickLink: function() {
                                    return setShowModalRegis(true);
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ChartHeader/* default */.Z, {
                                onExpand: function() {
                                    return setShowModalRegis(true);
                                },
                                onSelectTimeframe: function() {
                                    return setShowModalRegis(true);
                                },
                                timeframe: "1y",
                                chartType: "yield",
                                onSelectChartType: function() {
                                    return setShowModalRegis(true);
                                },
                                isChartVisible: true,
                                priceInfo: {
                                    bidPrice: finItem === null || finItem === void 0 ? void 0 : finItem.bid_price,
                                    offerPrice: finItem === null || finItem === void 0 ? void 0 : finItem.offer_price,
                                    yield: finItem === null || finItem === void 0 ? void 0 : finItem.yield
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Hero_styled/* ChartWrapper */.hC, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Chart_styled/* MainChartContent */.LH, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Chart_styled/* ChartContainer */.BO, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MainChart/* default */.Z, {
                                            disableChartbitLink: true,
                                            isLoadingChart: false,
                                            symbol: symbol,
                                            visible: true,
                                            chart: chart,
                                            timeframe: "1y",
                                            chartType: "yield",
                                            onClickChart: function() {
                                                return setShowModalRegis(true);
                                            }
                                        })
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Detail_styled/* DetailContainer */.Mv, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Detail_styled/* ContentContainer */.OO, {
                            style: {
                                border: "none"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Detail_styled/* ContentContainerLeft */.H0, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CouponDetail/* default */.Z, {
                                        annualRate: finItem.annual_coupon_rate,
                                        couponDistribution: finItem.coupon_distribution,
                                        dueDate: finItem.due_date,
                                        issuedDate: finItem.issued_date,
                                        minimumOrder: finItem.minimum_order,
                                        nextDate: finItem.next_coupon_date,
                                        issuer: issuer
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Detail_styled/* ContentContainerRight */.pD, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(About/* default */.Z, {
                                        data: about
                                    })
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(company_GuestRegisterModal, {
                isCompanyStock: true,
                visible: showModalRegis,
                setVisible: setShowModalRegis,
                features: GuestCompany_features
            })
        ]
    });
};
/* harmony default export */ var FRPage_GuestCompany = (GuestFRCompany);

;// CONCATENATED MODULE: ./pages/symbol/[symbol]/index.tsx

__webpack_require__(14473);











var Company = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(212), __webpack_require__.e(1991)]).then(__webpack_require__.bind(__webpack_require__, 11991));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(11991)
            ];
        }
    }
});
var SymbolPage = function(param) {
    var type = param.type, symbol = param.symbol, posts = param.posts, company = param.company, companyProfile = param.companyProfile, chart = param.chart, findData = param.findData;
    var router = (0,next_router.useRouter)();
    var _$param = router.query.param;
    var activeTab = _$param === null || _$param === void 0 ? void 0 : _$param[0];
    var isLoggedInState = (0,es/* useSelector */.v9)(credentials/* isLoggedInSelector */.dd);
    var ref = (0,react.useState)(false), isLoggedIn = ref[0], setIsLoggedIn = ref[1];
    var ref1 = (0,react.useState)(false), isRendered = ref1[0], setIsRendered = ref1[1];
    (0,react.useEffect)(function() {
        var accessToken = auth/* default.getToken */.Z.getToken().accessToken;
        var token = accessToken.token;
        setIsLoggedIn(!!token);
        setIsRendered(true);
    }, []);
    if (!isLoggedIn && !isLoggedInState && isRendered) {
        var ref2;
        var isCompanyStock = (company === null || company === void 0 ? void 0 : (ref2 = company.type_company) === null || ref2 === void 0 ? void 0 : ref2.toLowerCase()) === "saham";
        if (type === "FR") {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(FRPage_GuestCompany, {
                symbol: symbol,
                company: company,
                chart: chart,
                finItem: findData === null || findData === void 0 ? void 0 : findData.fr_fitem
            });
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(GuestCompany, {
            symbol: symbol,
            posts: posts,
            company: company,
            isCompanyStock: isCompanyStock,
            companyProfile: companyProfile,
            chart: chart
        });
    }
    if ((isLoggedIn || isLoggedInState) && isRendered) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Company, {
            symbol: symbol,
            tab: activeTab
        });
    }
    return null;
};
SymbolPage.getLayout = function getLayout(page) {
    var _props = page.props, props = _props === void 0 ? {} : _props;
    var _company = props.company, company = _company === void 0 ? {} : _company, type = props.type;
    var ref = (0,react.useState)(false), isLoggedIn = ref[0], setIsLoggedIn = ref[1];
    var ref1 = (0,react.useState)(false), isRendered = ref1[0], setIsRendered = ref1[1];
    (0,react.useEffect)(function() {
        var accessToken = auth/* default.getToken */.Z.getToken().accessToken;
        var token = accessToken.token;
        setIsLoggedIn(!!token);
        setIsRendered(true);
    }, []);
    if (isLoggedIn && isRendered) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(MainLayout["default"], {
            maxWidth: 1000,
            children: page
        });
    }
    if (!isLoggedIn && isRendered) {
        var ref2;
        var isCompanyStock = (company === null || company === void 0 ? void 0 : (ref2 = company.type_company) === null || ref2 === void 0 ? void 0 : ref2.toLowerCase()) === "saham" || type === "FR";
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(company_styled/* GuestDocumentLayout */.wE, {
            noBox: true,
            isCompanyStock: isCompanyStock,
            children: page
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SEO/* default */.Z, {
        title: company === null || company === void 0 ? void 0 : company.symbol,
        description: company === null || company === void 0 ? void 0 : company.name,
        image: company === null || company === void 0 ? void 0 : company.icon_url
    });
};
var __N_SSP = true;
/* harmony default export */ var _symbol_ = (SymbolPage);


/***/ }),

/***/ 46796:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "jL": function() { return /* binding */ Banner; },
  "zj": function() { return /* binding */ CustomGuestCompanyBackground; },
  "zD": function() { return /* binding */ EmptyWrapper; },
  "uf": function() { return /* binding */ GuestChartWrapper; },
  "wE": function() { return /* binding */ GuestDocumentLayout; },
  "rT": function() { return /* binding */ GuestNavbar; },
  "Y5": function() { return /* binding */ GuestStreamWrapper; },
  "DT": function() { return /* binding */ RegisterButton; }
});

// UNUSED EXPORTS: FinancialWrapper

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/@stockbit/ui/index.js
var ui = __webpack_require__(76825);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/global/Image/index.js
var Image = __webpack_require__(579);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
;// CONCATENATED MODULE: ./src/global/GuestLayout/styled.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  justify-content: center;\n  width: 100%;\n\n  a {\n    color: ",
        ";\n    text-decoration: none;\n    margin: 8px 4px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  padding: 10px;\n  min-height: 100vh;\n\n  @media ",
        " {\n    padding: 20px 0;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        background-color: ",
        ";\n\n        @media ",
        " {\n          border-bottom: 1px solid ",
        ";\n        }\n      "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        height: 72px;\n        padding: 22px 20px;\n\n        img {\n          height: 40px;\n          width: 75px;\n        }\n        button {\n          width: 99px;\n          height: 28px;\n        }\n        button.button-login p,\n        button.button-register p {\n          font-size: 12px;\n        }\n\n        @media ",
        " {\n          padding: 20px 10px;\n        }\n      "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        padding: 20px 10px;\n\n        img {\n          height: 40px;\n        }\n      "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: 930px;\n  ",
        "\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        padding: 0;\n\n        @media ",
        " {\n          padding: 20px 30px;\n        }\n\n        @media ",
        " {\n          padding: 20px 10px;\n        }\n      "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: 930px;\n  ",
        "\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}


var Flex = ui/* Common.Flex */.Gn.Flex;
var Footer = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-ff67680a-0"
})(_templateObject(), ui/* color.highempahis */.$_.highempahis);
var Wrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-ff67680a-1"
})(_templateObject1(), ui/* color.whiteSmoke */.$_.whiteSmoke, ui/* device.tablet */.Uh.tablet);
var HeaderContainer = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-ff67680a-2"
})(_templateObject3(), function(param) {
    var isGuestCompanyStock = param.isGuestCompanyStock;
    if (isGuestCompanyStock) {
        return (0,styled_components_browser_esm.css)(_templateObject2(), ui/* color.light */.$_.light, ui/* device.tablet */.Uh.tablet, ui/* color.gainsboro */.$_.gainsboro);
    }
});
var HeaderFlex = (0,styled_components_browser_esm["default"])(Flex).withConfig({
    componentId: "sc-ff67680a-3"
})(_templateObject6(), function(param) {
    var isGuestCompanyStock = param.isGuestCompanyStock;
    if (isGuestCompanyStock) {
        return (0,styled_components_browser_esm.css)(_templateObject4(), ui/* device.laptop */.Uh.laptop);
    } else {
        return (0,styled_components_browser_esm.css)(_templateObject5());
    }
});
var MainContainer = (0,styled_components_browser_esm["default"])(Flex).withConfig({
    componentId: "sc-ff67680a-4"
})(_templateObject8(), function(param) {
    var isGuestCompanyStock = param.isGuestCompanyStock;
    if (isGuestCompanyStock) {
        return (0,styled_components_browser_esm.css)(_templateObject7(), ui/* device.tablet */.Uh.tablet, ui/* device.laptop */.Uh.laptop);
    }
});


;// CONCATENATED MODULE: ./src/global/GuestLayout/index.tsx







var Button = ui/* Common.Button */.Gn.Button, GuestLayout_Flex = ui/* Common.Flex */.Gn.Flex, Text = ui/* Common.Text */.Gn.Text;
var Box = ui/* Statics.Box */.gP.Box;
var GuestLayout = function(param) {
    var children = param.children, _noBox = param.noBox, noBox = _noBox === void 0 ? false : _noBox, _noAuth = param.noAuth, noAuth = _noAuth === void 0 ? false : _noAuth, _isCompanyStock = param.isCompanyStock, isCompanyStock = _isCompanyStock === void 0 ? false : _isCompanyStock, _className = param.className, className = _className === void 0 ? "" : _className;
    var router = (0,next_router.useRouter)();
    var date = new Date();
    var year = date.getFullYear();
    var isGuestCompanyStock = isCompanyStock;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
        className: className,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderContainer, {
                isGuestCompanyStock: isGuestCompanyStock,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(HeaderFlex, {
                    align: "center",
                    direction: "row",
                    justify: "space-between",
                    mx: "auto",
                    isGuestCompanyStock: isGuestCompanyStock,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: "/",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                    src: "/images/stockbit.svg",
                                    alt: "stockbit logo"
                                })
                            })
                        }),
                        !noAuth && /*#__PURE__*/ (0,jsx_runtime.jsxs)(GuestLayout_Flex, {
                            direction: "row",
                            justify: "center",
                            align: "center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: "/login",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button, {
                                            mr: "16px",
                                            className: "button-login",
                                            mt: isGuestCompanyStock ? 0 : "8px",
                                            type: isGuestCompanyStock ? "default" : "borderless",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text, {
                                                family: isGuestCompanyStock ? "regular" : "bold",
                                                color: isGuestCompanyStock ? ui/* color.highempahis */.$_.highempahis : ui/* color.pinkSwan */.$_.pinkSwan,
                                                children: "Login"
                                            })
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: "/register",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button, {
                                            type: "primary",
                                            className: "button-register",
                                            mt: isGuestCompanyStock ? 0 : "8px",
                                            onClick: function(e) {
                                                e.preventDefault();
                                                router.push("/register");
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text, {
                                                family: isGuestCompanyStock ? "regular" : "bold",
                                                color: ui/* color.light */.$_.light,
                                                children: "Register"
                                            })
                                        })
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MainContainer, {
                mx: "auto",
                mb: "24px",
                isGuestCompanyStock: isGuestCompanyStock,
                children: noBox ? children : /*#__PURE__*/ (0,jsx_runtime.jsx)(Box, {
                    style: {
                        width: "100%"
                    },
                    children: children
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(GuestLayout_Flex, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Footer, {
                    children: [
                        "2013-",
                        year,
                        " Stockbit \xb7",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: "/about",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                children: "About"
                            })
                        }),
                        "\xb7",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: "/contact",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                children: "Contact"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: "https://help.stockbit.com/id",
                            children: "Help"
                        }),
                        "\xb7",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: "/rules",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                children: "House Rules"
                            })
                        }),
                        "\xb7",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: "/terms",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                children: "Terms"
                            })
                        }),
                        "\xb7",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: "/privacy",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                children: "Privacy"
                            })
                        })
                    ]
                })
            })
        ]
    });
};
GuestLayout.propTypes = {
    children: (prop_types_default()).node.isRequired,
    noBox: (prop_types_default()).bool,
    noAuth: (prop_types_default()).bool
};
GuestLayout.defaultProps = {
    noBox: false,
    noAuth: false
};
/* harmony default export */ var global_GuestLayout = (GuestLayout);

;// CONCATENATED MODULE: ./src/features/company/GuestCompanyBackground/styled.ts

function styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  border: solid 1px ",
        ";\n  margin-bottom: 20px;\n"
    ]);
    styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 12px 20px;\n  border-bottom: solid 1px ",
        ";\n\n  h2 {\n    margin: 0;\n    font-size: 16px;\n    color: ",
        ";\n  }\n"
    ]);
    styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 12px 20px;\n"
    ]);
    styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n"
    ]);
    styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}


var Tag = ui/* Company.TagCompany.Tag */.YD.TagCompany.Tag;
var MainWrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-3a8484b8-0"
})(styled_templateObject(), ui/* color.light */.$_.light, ui/* color.gainsboro */.$_.gainsboro);
var TitleWrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-3a8484b8-1"
})(styled_templateObject1(), ui/* color.gainsboro */.$_.gainsboro, ui/* color.black */.$_.black);
var BodyWrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-3a8484b8-2"
})(styled_templateObject2());
var ReadMore = styled_components_browser_esm["default"].a.withConfig({
    componentId: "sc-3a8484b8-3"
})(styled_templateObject3(), ui/* color.primary */.$_.primary);


;// CONCATENATED MODULE: ./src/features/company/GuestCompanyBackground/index.tsx



var GuestCompanyBackground_Text = ui/* Common.Text */.Gn.Text;
var GuestCompanyBackground = function(param) {
    var companyProfile = param.companyProfile, _className = param.className, className = _className === void 0 ? "" : _className, onClickReadMore = param.onClickReadMore;
    var textBody = companyProfile.background;
    var isLongText = textBody.length > 636;
    if (isLongText) textBody = "".concat(textBody.slice(0, 636), "...");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(MainWrapper, {
        className: className,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TitleWrapper, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                    children: "Company Background"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyWrapper, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(GuestCompanyBackground_Text, {
                    family: "regular",
                    size: "12px",
                    children: [
                        textBody,
                        " ",
                        isLongText && /*#__PURE__*/ (0,jsx_runtime.jsx)(ReadMore, {
                            onClick: function() {
                                return onClickReadMore(true);
                            },
                            children: "Read More"
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var company_GuestCompanyBackground = (GuestCompanyBackground);

// EXTERNAL MODULE: ./src/features/company/Navbar/index.tsx + 1 modules
var Navbar = __webpack_require__(67462);
;// CONCATENATED MODULE: ./src/features/company/styled.ts

function company_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      background-color: ",
        ";\n      height: calc(100% - 60px);\n      left: 0px;\n      margin: auto;\n      overflow-y: scroll;\n      padding: 20px;\n      position: fixed;\n      top: 60px;\n      z-index: 10;\n\n      @media ",
        " {\n        height: calc(100% - 100px);\n        top: 100px;\n        width: 100%;\n      }\n\n      @media ",
        " {\n        width: 100%;\n      }\n    "
    ]);
    company_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function company_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: auto;\n  padding-bottom: 20px;\n  width: 100%;\n\n  ",
        "\n"
    ]);
    company_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function company_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  background: ",
        ";\n  border: 1px solid ",
        ";\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  margin: 20px auto auto auto;\n  padding: 25px 0;\n  height: 320px;\n"
    ]);
    company_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function company_styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  display: flex;\n  height: 40px;\n  justify-content: center;\n  width: 100%;\n"
    ]);
    company_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function styled_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: none;\n\n  @media ",
        " {\n    display: flex;\n  }\n"
    ]);
    styled_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function styled_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  padding: 0;\n\n  @media ",
        " {\n    padding: 0;\n  }\n\n  @media ",
        " {\n    background-color: ",
        ";\n    padding: 0;\n  }\n"
    ]);
    styled_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function styled_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 0 20px 20px;\n\n  @media ",
        " {\n    margin: 0 0 20px 0;\n  }\n"
    ]);
    styled_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function styled_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      margin: 0 20px 20px;\n\n      @media ",
        " {\n        margin: 0px 0 20px 0;\n      }\n    "
    ]);
    styled_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function styled_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    styled_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      padding: 0 20px;\n\n      @media ",
        " {\n        padding: 0;\n      }\n    "
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: #fff;\n  padding: 12px 0;\n  margin-bottom: 20px;\n\n  @media ",
        " {\n    border: 1px solid ",
        ";\n    border-top: none;\n  }\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}





var styled_Button = ui/* Common.Button */.Gn.Button, styled_Flex = ui/* Common.Flex */.Gn.Flex;
// eslint-disable-next-line space-infix-ops
var FinancialWrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-5d6c0a4f-0"
})(company_styled_templateObject1(), function(param) {
    var fullscreen = param.fullscreen;
    return fullscreen && (0,styled_components_browser_esm.css)(company_styled_templateObject(), ui/* color.light */.$_.light, ui/* device.tablet */.Uh.tablet, ui/* device.laptop */.Uh.laptop);
});
var EmptyWrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-5d6c0a4f-1"
})(company_styled_templateObject2(), ui/* color.light */.$_.light, ui/* color.gainsboro */.$_.gainsboro);
var RegisterButton = (0,styled_components_browser_esm["default"])(styled_Button).attrs({
    type: "primary",
    as: "a"
}).withConfig({
    componentId: "sc-5d6c0a4f-2"
})(company_styled_templateObject3());
var Banner = styled_components_browser_esm["default"].div.attrs({
    type: "primary",
    as: "a"
}).withConfig({
    componentId: "sc-5d6c0a4f-3"
})(styled_templateObject4(), ui/* device.tablet */.Uh.tablet);
var GuestDocumentLayout = (0,styled_components_browser_esm["default"])(global_GuestLayout).withConfig({
    componentId: "sc-5d6c0a4f-4"
})(styled_templateObject5(), ui/* color.light */.$_.light, ui/* device.tablet */.Uh.tablet, ui/* device.laptop */.Uh.laptop, ui/* color.whiteSmoke */.$_.whiteSmoke);
var CustomGuestCompanyBackground = (0,styled_components_browser_esm["default"])(company_GuestCompanyBackground).withConfig({
    componentId: "sc-5d6c0a4f-5"
})(styled_templateObject6(), ui/* device.tablet */.Uh.tablet);
var GuestNavbar = (0,styled_components_browser_esm["default"])(Navbar/* default */.Z).withConfig({
    componentId: "sc-5d6c0a4f-6"
})(styled_templateObject8(), function(param) {
    var isCompanyStock = param.isCompanyStock;
    return isCompanyStock && (0,styled_components_browser_esm.css)(styled_templateObject7(), ui/* device.tablet */.Uh.tablet);
});
var GuestStreamWrapper = (0,styled_components_browser_esm["default"])(styled_Flex).withConfig({
    componentId: "sc-5d6c0a4f-7"
})(_templateObject10(), function(param) {
    var isCompanyStock = param.isCompanyStock;
    return isCompanyStock && (0,styled_components_browser_esm.css)(_templateObject9(), ui/* device.tablet */.Uh.tablet);
});
var GuestChartWrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-5d6c0a4f-8"
})(_templateObject11(), ui/* device.tablet */.Uh.tablet, ui/* color.gainsboro */.$_.gainsboro);



/***/ }),

/***/ 73442:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ AuthButtonView; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(76825);
/* harmony import */ var global_Image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(579);
/* harmony import */ var _styled__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(89213);




var Text = _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .Common.Text */ .Gn.Text;
function AuthButtonView(param) {
    var iconUrl = param.iconUrl, text = param.text, _isFilled = param.isFilled, isFilled = _isFilled === void 0 ? false : _isFilled;
    var textColor = isFilled ? _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.black */ .$_.black : _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.light */ .$_.light;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_styled__WEBPACK_IMPORTED_MODULE_3__/* .ButtonContainer */ .qO, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_3__/* .ButtonIcon */ .Ei, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(global_Image__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                    src: iconUrl,
                    width: 24,
                    height: 24
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Text, {
                color: textColor,
                size: "14px",
                family: "bold",
                children: text
            })
        ]
    });
};


/***/ }),

/***/ 72099:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(26042);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(76825);
/* harmony import */ var _greatsumini_react_facebook_login__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(73502);
/* harmony import */ var _greatsumini_react_facebook_login__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_greatsumini_react_facebook_login__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2497);
/* harmony import */ var utils_clevertap__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(48028);
/* harmony import */ var _AuthButton__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(73442);
/* harmony import */ var _assets_base64icon__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(54392);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(28456);
/* harmony import */ var _slice__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(2915);






// Assets



// State

var Text = _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .Common.Text */ .Gn.Text, Button = _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .Common.Button */ .Gn.Button, IconBase64 = _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .Common.IconBase64 */ .Gn.IconBase64;
var fbAppId = "247631672013136";
function FacebookOauth(param) {
    var _variant = param.variant, variant = _variant === void 0 ? "main" : _variant, _size = param.size, size = _size === void 0 ? "large" : _size, _isCompanyStock = param.isCompanyStock, isCompanyStock = _isCompanyStock === void 0 ? false : _isCompanyStock;
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_3__/* .useDispatch */ .I0)();
    var isLoading = (0,react_redux__WEBPACK_IMPORTED_MODULE_3__/* .useSelector */ .v9)(_slice__WEBPACK_IMPORTED_MODULE_7__/* .selectors */ .wl).isLoading;
    var textButton = "Register with Facebook";
    var handleCallback = {
        accessToken: "",
        success: function(response) {
            if (response === null || response === void 0 ? void 0 : response.accessToken) {
                handleCallback.accessToken = response.accessToken;
            }
        },
        profileSuccess: function(response) {
            if (handleCallback.accessToken !== "") {
                dispatch(_slice__WEBPACK_IMPORTED_MODULE_7__/* .effects.generateUsername */ .Sz.generateUsername((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
                    accessToken: handleCallback.accessToken
                }, response)));
            }
        }
    };
    var onCallClevertapEvent = function() {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_4__/* .clevertapEvent */ .Lq)("Register Selected", {
            "Register Method": _constants__WEBPACK_IMPORTED_MODULE_6__/* .registerTypes.FACEBOOK */ .E8.FACEBOOK
        });
    };
    var renderMainButton = function(onClick) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Button, {
            id: "facebook-register",
            type: "facebook",
            height: "44px",
            loading: isLoading,
            justifyContent: "start",
            block: true,
            onClick: function(e) {
                onCallClevertapEvent();
                onClick(e);
            },
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_AuthButton__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                iconUrl: "/icon/register/icon-facebook.svg",
                text: textButton
            })
        });
    };
    var renderSecondaryButton = function(onClick) {
        var buttonHeight = "".concat(size === "medium" ? 30.8 : 44, "px");
        var iconSize = "".concat(size === "medium" ? 16.8 : 24, "px");
        var fontSize = "".concat(size === "medium" ? 9.8 : 14, "px");
        var iconPadding = isCompanyStock ? "10px" : "unset";
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Button, {
            id: "facebook-register",
            height: buttonHeight,
            loading: isLoading,
            justifyContent: "start",
            block: true,
            round: true,
            onClick: function(e) {
                onCallClevertapEvent();
                onClick(e);
            },
            style: {
                paddingLeft: 20,
                paddingRight: 20
            },
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconBase64, {
                    icon: _assets_base64icon__WEBPACK_IMPORTED_MODULE_9__/* .facebookIconBlue */ .$P,
                    iconSize: iconSize,
                    padding: iconPadding
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Text, {
                    color: "light",
                    size: fontSize,
                    family: "bold",
                    width: "100%",
                    align: "center",
                    children: textButton
                })
            ]
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((_greatsumini_react_facebook_login__WEBPACK_IMPORTED_MODULE_2___default()), {
        appId: fbAppId,
        fields: "name,email,picture",
        onSuccess: handleCallback.success,
        onProfileSuccess: handleCallback.profileSuccess,
        render: function(param) {
            var onClick = param.onClick;
            if (variant === "secondary") {
                return renderSecondaryButton(onClick);
            }
            return renderMainButton(onClick);
        }
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (FacebookOauth);


/***/ }),

/***/ 79106:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(76825);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2497);
/* harmony import */ var react_google_login__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(93645);
/* harmony import */ var react_google_login__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(react_google_login__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var utils_clevertap__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(48028);
/* harmony import */ var assets_base64icon__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(54392);
/* harmony import */ var _AuthButton__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(73442);
/* harmony import */ var _slice__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(84405);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(28456);




// Assets



// State


var Text = _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .Common.Text */ .Gn.Text, Button = _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .Common.Button */ .Gn.Button, IconBase64 = _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .Common.IconBase64 */ .Gn.IconBase64;
var googleClientId = "867806581579-u0ubjbmo7u3ikv05j099paceeirj6olm.apps.googleusercontent.com";
function GoogleOauth(param) {
    var _variant = param.variant, variant = _variant === void 0 ? "main" : _variant, _size = param.size, size = _size === void 0 ? "large" : _size, _isCompanyStock = param.isCompanyStock, isCompanyStock = _isCompanyStock === void 0 ? false : _isCompanyStock;
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useDispatch */ .I0)();
    var isLoading = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(_slice__WEBPACK_IMPORTED_MODULE_6__/* .selectors */ .wl).isLoading;
    var textButton = "Register with Google";
    var onCallClevertapEvent = function() {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_4__/* .clevertapEvent */ .Lq)("Register Selected", {
            "Register Method": _constants__WEBPACK_IMPORTED_MODULE_7__/* .registerTypes.GOOGLE */ .E8.GOOGLE
        });
    };
    var handleOauthCallback = function(response) {
        if (!response.error) {
            dispatch(_slice__WEBPACK_IMPORTED_MODULE_6__/* .effects.generateUsername */ .Sz.generateUsername(response));
        }
    };
    var renderMainButton = function(onClick) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Button, {
            id: "google-register",
            height: "44px",
            mt: "10px",
            loading: isLoading,
            block: true,
            onClick: function(e) {
                onCallClevertapEvent();
                onClick(e);
            },
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_AuthButton__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                iconUrl: "/icon/register/icon-google.svg",
                text: textButton,
                isFilled: true
            })
        });
    };
    var renderSecondaryButton = function(onClick) {
        var buttonHeight = "".concat(size === "medium" ? 30.8 : 44, "px");
        var iconSize = "".concat(size === "medium" ? 16.8 : 24, "px");
        var fontSize = "".concat(size === "medium" ? 9.8 : 14, "px");
        var icon = isCompanyStock ? assets_base64icon__WEBPACK_IMPORTED_MODULE_8__/* .newGoogleIcon */ .XT : assets_base64icon__WEBPACK_IMPORTED_MODULE_8__/* .googleIcon */ .HM;
        var iconPadding = isCompanyStock ? "10px" : "unset";
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Button, {
            block: true,
            round: true,
            mb: "16px",
            height: buttonHeight,
            justifyContent: "start",
            loading: isLoading,
            id: "google-register",
            style: {
                paddingLeft: 20,
                paddingRight: 20
            },
            onClick: function(e) {
                onCallClevertapEvent();
                onClick(e);
            },
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconBase64, {
                    icon: icon,
                    iconSize: iconSize,
                    padding: iconPadding
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Text, {
                    color: "light",
                    size: fontSize,
                    family: "bold",
                    width: "100%",
                    align: "center",
                    children: textButton
                })
            ]
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((react_google_login__WEBPACK_IMPORTED_MODULE_3___default()), {
        clientId: googleClientId,
        buttonText: "Register",
        onSuccess: handleOauthCallback,
        onFailure: handleOauthCallback,
        cookiePolicy: "single_host_origin",
        className: "register-with-google-button hide",
        render: function(param) {
            var onClick = param.onClick;
            if (variant === "secondary") {
                return renderSecondaryButton(onClick);
            }
            return renderMainButton(onClick);
        }
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (GoogleOauth);


/***/ }),

/***/ 89213:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BH": function() { return /* binding */ RegisterStyle; },
/* harmony export */   "Ei": function() { return /* binding */ ButtonIcon; },
/* harmony export */   "II": function() { return /* binding */ Input; },
/* harmony export */   "KM": function() { return /* binding */ InputPinContainer; },
/* harmony export */   "Pk": function() { return /* binding */ InputPhoneContainer; },
/* harmony export */   "Rn": function() { return /* binding */ InputNumber; },
/* harmony export */   "Tc": function() { return /* binding */ InputPinWrapper; },
/* harmony export */   "cW": function() { return /* binding */ CustomStyle; },
/* harmony export */   "fv": function() { return /* binding */ InputContainer; },
/* harmony export */   "qO": function() { return /* binding */ ButtonContainer; }
/* harmony export */ });
/* unused harmony exports Spacer, TextInfo, Wrapper */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(76825);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19521);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  box-sizing: border-box;\n  background-color: ",
        ";\n  border: 1px solid ",
        ";\n  border-radius: 4px;\n  box-shadow: 0 0 10px ",
        ";\n\n  @media ",
        " {\n    width: 100%;\n    padding: 20px 40px;\n  }\n\n  @media ",
        " {\n    width: 450px;\n    padding: 40px 70px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: relative;\n\n  .phone-dropdown-button {\n    background-color: transparent !important;\n    border: none;\n\n    div {\n      border: none;\n    }\n\n    .arrow {\n      left: 24px;\n      border-left: 4px solid transparent;\n      border-right: 4px solid transparent;\n      border-top: 5px solid #555;\n    }\n  }\n\n  .phone-input {\n    font-size: 15px !important;\n    line-height: 19px;\n    font-weight: 700 !important;\n    color: #333333 !important;\n  }\n\n  .phone-input::placeholder {\n    font-weight: 400 !important;\n  }\n\n  button {\n    background: transparent;\n    border: none;\n    position: absolute;\n    right: 0;\n    top: 20%;\n    cursor: pointer;\n  }\n\n  img {\n    width: 16px;\n    height: 16px;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-size: 20px;\n  padding: 0;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 30px;\n  margin-right: 10px;\n  overflow: hidden;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border: none;\n  border-bottom: 1px solid ",
        ";\n  width: 45px;\n  font-size: 22px;\n  font-weight: bold;\n  text-align: center;\n  padding: 0;\n\n  :focus,\n  :hover {\n    border-bottom: 1px solid ",
        ";\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-size: 12px;\n  color: ",
        ";\n  text-align: center;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  /* Hide google recaptcha */\n    .grecaptcha-badge {\n      opacity: 1;\n      visibility: visible;\n    }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      height: ",
        "px;\n    "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  align-items: center;\n  gap: 50px;\n  align-self: stretch;\n  width: 100%;\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 24px;\n  height: 24px;\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin-top: -20px;\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .register,\n  .login {\n    display: flex;\n    flex-direction: column;\n    gap: 24px;\n    border: none;\n\n    button.ant-btn {\n      border-radius: 4px;\n      padding: 5px 16px;\n    }\n\n    button.ant-btn-facebook {\n      background: #33579D;\n    }\n\n    button.btn-successful-register {\n      border-radius: 4px;\n    }\n\n    button.ant-btn-default {\n      border: 1px solid ",
        ";\n    }\n\n    button.ant-btn .ant-btn-loading-icon {\n      display: flex;\n    }\n\n    button:disabled, button:disabled:hover {\n      background-color: #8CD9BC !important;\n      border-color: #8CD9BC !important;\n\n      p {\n        color: ",
        " !important;\n      }\n    }\n\n    .form-divider {\n      margin: 10px 20px;\n      width: auto;\n      \n      p {\n        font-family: ProximaNovaLt;\n      }\n    }\n\n    @media ",
        " {\n      width: 100% !important;\n      padding: 28px 30px !important;\n    }\n\n    @media ",
        " {\n      width: 450px !important;\n      padding: 32px 40px !important;\n    }\n  }\n\n  .auth-text-container {\n    padding: 0;\n  }\n\n  .ant-message-notice.sysmsg-content {\n    max-width: 440px !important;\n  }\n\n  @media ",
        " {\n    .ant-tooltip-placement-leftTop {\n      display: none;\n    }\n\n    .ant-tooltip-hidden {\n      display: none !important;\n    }\n  }\n\n  @media ",
        " {\n    .ant-tooltip-placement-leftTop {\n      display: block;\n    }\n\n    .ant-tooltip-hidden {\n      display: none !important;\n    }\n  }\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  justify-content: center;\n  gap: 10px;\n  margin: 24px 0 20px;\n\n  input {\n    border: none;\n    border-bottom: 1px solid ",
        ";\n    width: 35px;\n    height: 40px;\n    font-size: 24px;\n    font-weight: bold;\n    text-align: center;\n    outline: none;\n  }\n\n  input:focus,\n  input.filled {\n    border-color: ",
        ";\n  }\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}


var InputDefault = _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .Common.Input */ .Gn.Input, Text = _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .Common.Text */ .Gn.Text;
var Wrapper = styled_components__WEBPACK_IMPORTED_MODULE_2__["default"].div.withConfig({
    componentId: "sc-2e21e613-0"
})(_templateObject(), _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.light */ .$_.light, _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.light */ .$_.light, _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.lowgray */ .$_.lowgray, _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .device.mobileS */ .Uh.mobileS, _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .device.tablet */ .Uh.tablet);
var InputPhoneContainer = styled_components__WEBPACK_IMPORTED_MODULE_2__["default"].div.withConfig({
    componentId: "sc-2e21e613-1"
})(_templateObject1());
var Input = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__["default"])(InputDefault).withConfig({
    componentId: "sc-2e21e613-2"
})(_templateObject2());
var InputContainer = styled_components__WEBPACK_IMPORTED_MODULE_2__["default"].div.withConfig({
    componentId: "sc-2e21e613-3"
})(_templateObject3());
var InputNumber = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__["default"])(InputDefault).withConfig({
    componentId: "sc-2e21e613-4"
})(_templateObject4(), _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.primary */ .$_.primary, _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.primary */ .$_.primary);
var TextInfo = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__["default"])(Text).withConfig({
    componentId: "sc-2e21e613-5"
})(_templateObject5(), _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.dimGray */ .$_.dimGray);
var CustomStyle = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__.createGlobalStyle)(_templateObject6());
var Spacer = styled_components__WEBPACK_IMPORTED_MODULE_2__["default"].div.withConfig({
    componentId: "sc-2e21e613-6"
})(_templateObject8(), function(param) {
    var height = param.height;
    return height && (0,styled_components__WEBPACK_IMPORTED_MODULE_2__.css)(_templateObject7(), height);
});
var ButtonContainer = styled_components__WEBPACK_IMPORTED_MODULE_2__["default"].div.withConfig({
    componentId: "sc-2e21e613-7"
})(_templateObject9());
var ButtonIcon = styled_components__WEBPACK_IMPORTED_MODULE_2__["default"].div.withConfig({
    componentId: "sc-2e21e613-8"
})(_templateObject10());
var InputPinContainer = styled_components__WEBPACK_IMPORTED_MODULE_2__["default"].div.withConfig({
    componentId: "sc-2e21e613-9"
})(_templateObject11());
var RegisterStyle = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__.createGlobalStyle)(_templateObject12(), _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.downgray */ .$_.downgray, _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.light */ .$_.light, _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .device.mobileS */ .Uh.mobileS, _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .device.mobileL */ .Uh.mobileL, _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .device.mobileS */ .Uh.mobileS, _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .device.laptop */ .Uh.laptop);
var InputPinWrapper = styled_components__WEBPACK_IMPORTED_MODULE_2__["default"].div.withConfig({
    componentId: "sc-2e21e613-10"
})(_templateObject13(), _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.highgray */ .$_.highgray, _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.primary */ .$_.primary);



/***/ }),

/***/ 21776:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _ant_design_icons__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(24969);
/* harmony import */ var _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(76825);
/* harmony import */ var _styled__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(65299);




var Text = _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .Common.Text */ .Gn.Text;
function EmptyState(param) {
    var _description = param.description, description = _description === void 0 ? "Add your favourite investors and monitor your stocks" : _description, onDiscover = param.onDiscover;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_styled__WEBPACK_IMPORTED_MODULE_2__/* .EmptyStateWrapper */ .$c, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_2__/* .Img */ .Ei, {
                src: "/images/empty_stream_box.png",
                alt: "Empty stream"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_styled__WEBPACK_IMPORTED_MODULE_2__/* .ContentWrapper */ .vs, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Text, {
                        family: "bold",
                        size: "18px",
                        mb: "10px",
                        children: "Your Stream is Empty"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Text, {
                        size: "16px",
                        color: _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.highgray */ .$_.highgray,
                        weight: "bold",
                        mb: "32px",
                        children: description
                    }),
                    onDiscover ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_styled__WEBPACK_IMPORTED_MODULE_2__/* .ButtonDiscover */ .$A, {
                        onClick: onDiscover,
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ant_design_icons__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                style: {
                                    marginRight: "8px"
                                }
                            }),
                            "Discover"
                        ]
                    }) : null
                ]
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (EmptyState);


/***/ }),

/***/ 90668:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(69396);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _stockbit_ui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(76825);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2497);
/* harmony import */ var global_Image__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(579);
/* harmony import */ var global_ModalShare__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(41232);
/* harmony import */ var lib_entities_chat_slice__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(10707);
/* harmony import */ var lib_entities_profile__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(333);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(36084);
/* harmony import */ var hooks_useTooltip__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(30627);
/* harmony import */ var constants_app__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(86123);
/* harmony import */ var features_stream_analytics_StreamTabAnalytics__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(99093);
/* harmony import */ var utils_source__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(9486);
/* harmony import */ var _Modals__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(50700);
/* harmony import */ var _styled__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(97986);
/* harmony import */ var _slice__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(47225);
/* harmony import */ var _tests_constants__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(18278);
/* eslint-disable no-unused-vars */ 




















var Flex = _stockbit_ui__WEBPACK_IMPORTED_MODULE_2__/* .Common.Flex */ .Gn.Flex, Text = _stockbit_ui__WEBPACK_IMPORTED_MODULE_2__/* .Common.Text */ .Gn.Text, Iconmoon = _stockbit_ui__WEBPACK_IMPORTED_MODULE_2__/* .Common.Iconmoon */ .Gn.Iconmoon, IconWrapper = _stockbit_ui__WEBPACK_IMPORTED_MODULE_2__/* .Common.IconWrapper */ .Gn.IconWrapper;
var LS_TOOLTIP_SHARE = "tooltipShare";
function Footer(param) {
    var post = param.post, onComment = param.onComment, _symbol = param.symbol, symbol = _symbol === void 0 ? "" : _symbol, _hideLikers = param.hideLikers, hideLikers = _hideLikers === void 0 ? false : _hideLikers, _isFirstPost = param.isFirstPost, isFirstPost = _isFirstPost === void 0 ? false : _isFirstPost;
    var pageSource = (0,utils_source__WEBPACK_IMPORTED_MODULE_12__/* .getAnalyticsPageSource */ .u)();
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_4__/* .useDispatch */ .I0)();
    var ref = (0,react_redux__WEBPACK_IMPORTED_MODULE_4__/* .useSelector */ .v9)(lib_entities_profile__WEBPACK_IMPORTED_MODULE_8__/* .selectors */ .wl), profileData = ref.data;
    var _country = profileData.country, country = _country === void 0 ? "ID" : _country;
    var ref1 = (0,hooks_useTooltip__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(LS_TOOLTIP_SHARE), showShareTolltip = ref1.showTooltip, onCloseShareTooltip = ref1.onCloseTooltip;
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false), modalShare = ref2[0], showModalShare = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false), modalInsight = ref3[0], showModalInsight = ref3[1];
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false), modalTipping = ref4[0], showModalTipping = ref4[1];
    var ref5 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false), modalLike = ref5[0], showModalLike = ref5[1];
    var likes = post.likes, replies = post.replies, liked = post.liked, postid = post.postid;
    // TODO: handle logic in footer
    /**
   * - Handle like post -> button after liked/unliked (DONE)
   * - Open modal conversation
   * - Hide tipjar icon if post.userid === current userid
   */ var handleLikePost = function() {
        var action = liked ? _slice__WEBPACK_IMPORTED_MODULE_15__/* .effects.unlikePost */ .Sz.unlikePost : _slice__WEBPACK_IMPORTED_MODULE_15__/* .effects.likePost */ .Sz.likePost;
        // @ts-ignore
        dispatch(action(postid));
    };
    var handleShareToChat = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(chatData) {
            var send, error;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return dispatch(lib_entities_chat_slice__WEBPACK_IMPORTED_MODULE_7__/* .effects.sendBulkChat */ .Sz.sendBulkChat((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)({}, chatData), {
                            attachment_url: "",
                            shared_content: {
                                type: "SHARED_CONTENT_TYPE_STREAM",
                                id: post.postid
                            }
                        })));
                    case 2:
                        send = _ctx.sent;
                        error = send.payload.error;
                        if (!error) {
                            showModalShare(false);
                        }
                    case 5:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleShareToChat(chatData) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleClickShare = function() {
        if (pageSource) {
            features_stream_analytics_StreamTabAnalytics__WEBPACK_IMPORTED_MODULE_11__/* ["default"].common.Action.clickShareButton */ .ZP.common.Action.clickShareButton(pageSource);
        }
        showModalShare(true);
    };
    var handleClickTip = function() {
        if (pageSource) {
            features_stream_analytics_StreamTabAnalytics__WEBPACK_IMPORTED_MODULE_11__/* ["default"].common.Action.clickTipping */ .ZP.common.Action.clickTipping({
                pageSource: pageSource,
                streamId: post.postid,
                userId: post.userid
            });
        }
        showModalTipping(true);
    };
    var urlToShare = (0,react__WEBPACK_IMPORTED_MODULE_3__.useMemo)(function() {
        var path = !constants_app__WEBPACK_IMPORTED_MODULE_10__/* .PROJECT_FOLDER */ .sP || constants_app__WEBPACK_IMPORTED_MODULE_10__/* .PROJECT_FOLDER */ .sP === "/" ? "/" : "/".concat(constants_app__WEBPACK_IMPORTED_MODULE_10__/* .PROJECT_FOLDER */ .sP, "/");
        return "".concat(window.location.origin).concat(path, "post/").concat(post.postid);
    }, [
        post
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_styled__WEBPACK_IMPORTED_MODULE_14__/* .FooterContainer */ .bk, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Flex, {
                justify: "space-between",
                align: "flex-end",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Flex, {
                        align: "flex-end",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                children: [
                                    !hideLikers ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Text, {
                                        as: "a",
                                        className: "likes-info",
                                        onClick: function() {
                                            return showModalLike(true);
                                        },
                                        children: likes > 0 && "".concat(likes, " likes")
                                    }) : null,
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Flex, {
                                        padding: "10px 20px 0 0",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(IconWrapper, {
                                            onClick: handleLikePost,
                                            "data-cy": symbol ? _tests_constants__WEBPACK_IMPORTED_MODULE_19__/* .DATA_CY_FOOTER_LIKE_BUTTON_COMPANY */ .KL : _tests_constants__WEBPACK_IMPORTED_MODULE_19__/* .DATA_CY_FOOTER_LIKE_BUTTON */ .l,
                                            children: liked ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(global_Image__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                                src: "/icon/post-stream/like-fill.svg",
                                                alt: "Like post filled",
                                                style: {
                                                    width: "20px"
                                                }
                                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(global_Image__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                                src: "/icon/post-stream/like.svg",
                                                alt: "Like post",
                                                style: {
                                                    width: "20px"
                                                }
                                            })
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Flex, {
                                padding: "0 20px 0 0",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(antd__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z, {
                                    placement: "top",
                                    title: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Text, {
                                        color: _stockbit_ui__WEBPACK_IMPORTED_MODULE_2__/* .color.light */ .$_.light,
                                        family: "bold",
                                        size: "12px",
                                        height: "22px",
                                        onClick: onCloseShareTooltip,
                                        children: "Share to friends"
                                    }),
                                    defaultVisible: showShareTolltip && isFirstPost,
                                    visible: showShareTolltip && isFirstPost,
                                    overlayClassName: "tooltip-overlay-green",
                                    overlayInnerStyle: {
                                        background: _stockbit_ui__WEBPACK_IMPORTED_MODULE_2__/* .color.primary */ .$_.primary,
                                        padding: "6px 8px"
                                    },
                                    zIndex: 99,
                                    arrowPointAtCenter: true,
                                    onVisibleChange: function(open) {
                                        return onCloseShareTooltip();
                                    },
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(IconWrapper, {
                                        onClick: handleClickShare,
                                        "data-cy": symbol ? _tests_constants__WEBPACK_IMPORTED_MODULE_19__/* .DATA_CY_FOOTER_SHARE_BUTTON_COMPANY */ .H9 : _tests_constants__WEBPACK_IMPORTED_MODULE_19__/* .DATA_CY_FOOTER_SHARE_BUTTON */ .On,
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(global_Image__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                            src: "/icon/post-stream/share.svg",
                                            alt: "Share post",
                                            style: {
                                                width: "20px"
                                            }
                                        })
                                    })
                                })
                            }),
                            post.analytics && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(IconWrapper, {
                                padding: "0 20px 0 0",
                                onClick: function() {
                                    return showModalInsight(true);
                                },
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Iconmoon, {
                                    className: "icon-new_analytics",
                                    size: "16px",
                                    color: _stockbit_ui__WEBPACK_IMPORTED_MODULE_2__/* .color.dimgray */ .$_.dimgray,
                                    hoverColor: _stockbit_ui__WEBPACK_IMPORTED_MODULE_2__/* .color.dimgray */ .$_.dimgray
                                })
                            }),
                            !post.is_author && country === "ID" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(IconWrapper, {
                                padding: "0 20px 0 0",
                                onClick: handleClickTip,
                                "data-cy": symbol ? _tests_constants__WEBPACK_IMPORTED_MODULE_19__/* .DATA_CY_FOOTER_TIP_BUTTON_COMPANY */ .tJ : _tests_constants__WEBPACK_IMPORTED_MODULE_19__/* .DATA_CY_FOOTER_TIP_BUTTON */ .vI,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(global_Image__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                    src: "/icon/post-stream/icon-tip.svg",
                                    alt: "Icon Tip",
                                    style: {
                                        width: "20px"
                                    }
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Flex, {
                        onClick: onComment,
                        style: {
                            alignItems: "flex-end"
                        },
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Text, {
                                padding: "0 8px 0",
                                children: parseInt(replies, 10) > 0 && replies
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(IconWrapper, {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(global_Image__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                    src: "/icon/post-stream/comment.svg",
                                    alt: "Icon Comment New",
                                    style: {
                                        width: "20px"
                                    },
                                    "data-cy": symbol ? _tests_constants__WEBPACK_IMPORTED_MODULE_19__/* .DATA_CY_STREAM_COMMENT_ICON_COMPANY */ .dJ : _tests_constants__WEBPACK_IMPORTED_MODULE_19__/* .DATA_CY_STREAM_COMMENT_ICON */ .Vi
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(global_ModalShare__WEBPACK_IMPORTED_MODULE_6__["default"], {
                post: post,
                sendChat: handleShareToChat,
                title: "Share",
                hasCopyButton: true,
                hasRepostButton: post.is_author === 0,
                hasSearchPeople: true,
                hasSocialMedia: true,
                hasShareInput: true,
                urlToShare: urlToShare,
                visible: modalShare,
                onCancel: function() {
                    return showModalShare(false);
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Modals__WEBPACK_IMPORTED_MODULE_13__/* .ModalInsight */ .eV, {
                visible: modalInsight,
                post: post,
                onCancel: function() {
                    return showModalInsight(false);
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Modals__WEBPACK_IMPORTED_MODULE_13__/* .ModalTipping */ .MW, {
                streamId: postid,
                userId: post.userid,
                username: post.username,
                avatar: post.avatar,
                visible: modalTipping,
                onCancel: function() {
                    return showModalTipping(false);
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Modals__WEBPACK_IMPORTED_MODULE_13__/* .ModalLike */ .gU, {
                likes: likes,
                streamId: postid,
                visible: modalLike,
                onCancel: function() {
                    return showModalLike(false);
                }
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["default"] = (Footer);


/***/ }),

/***/ 82592:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(76825);


var Flex = _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .Common.Flex */ .Gn.Flex, IconWrapper = _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .Common.IconWrapper */ .Gn.IconWrapper, Iconmoon = _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .Common.Iconmoon */ .Gn.Iconmoon, Text = _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .Common.Text */ .Gn.Text;
function PinnedLabel(param) {
    var isCompanyPinnedPost = param.isCompanyPinnedPost, _text = param.text, text = _text === void 0 ? "Pinned Post" : _text, _marginBottom = param.marginBottom, marginBottom = _marginBottom === void 0 ? "16px" : _marginBottom;
    var color = isCompanyPinnedPost ? "#858585" : "#e32072";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Flex, {
        ml: isCompanyPinnedPost ? "0px" : "50px",
        align: "center",
        mb: marginBottom,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconWrapper, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Iconmoon, {
                    className: "icon-toolbar_pinned",
                    size: "16px",
                    color: color
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Text, {
                ml: isCompanyPinnedPost ? "4px" : "8px",
                color: color,
                children: text
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (PinnedLabel);


/***/ }),

/***/ 3841:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ StreamWidget_Post; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(36305);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/@stockbit/ui/index.js
var ui = __webpack_require__(76825);
// EXTERNAL MODULE: ./src/global/ImageSlider/index.tsx + 7 modules
var ImageSlider = __webpack_require__(9649);
// EXTERNAL MODULE: ./src/global/Image/index.js
var Image = __webpack_require__(579);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 17 modules
var es = __webpack_require__(2497);
// EXTERNAL MODULE: ./src/lib/entities/credentials.js + 4 modules
var credentials = __webpack_require__(21671);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/global/StreamWidget/PollingContainer/index.tsx + 2 modules
var PollingContainer = __webpack_require__(78690);
// EXTERNAL MODULE: ./src/global/StreamWidget/TargetPriceContainer/index.tsx + 2 modules
var TargetPriceContainer = __webpack_require__(18562);
// EXTERNAL MODULE: ./src/global/StreamWidget/TextContent/index.tsx
var TextContent = __webpack_require__(13683);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/global/Labels/index.tsx + 5 modules
var Labels = __webpack_require__(94493);
// EXTERNAL MODULE: ./src/constants/api.js
var api = __webpack_require__(37213);
// EXTERNAL MODULE: ./src/utils/general.js
var general = __webpack_require__(42227);
// EXTERNAL MODULE: ./src/global/StreamWidget/Post/styled.ts
var styled = __webpack_require__(97986);
;// CONCATENATED MODULE: ./src/global/StreamWidget/Post/Comment.tsx












var Flex = ui/* Common.Flex */.Gn.Flex, Avatar = ui/* Common.Avatar */.Gn.Avatar;
function Comment(_param) {
    var comment = _param.comment, props = (0,_object_without_properties/* default */.Z)(_param, [
        "comment"
    ]);
    var avatar = comment.avatar, content = comment.content, maskedHtml = comment.mask_html, username = comment.username, created = comment.created_display, official = comment.official, isVerified = comment.is_verified, privilege = comment.user_priv;
    var avatarUrl = avatar.startsWith("http") ? avatar : "".concat(api/* AVATAR_URL */.q$, "/").concat(avatar);
    // Note :
    // From backend in stream post the type of official param is number
    // but stream post inside the last_reply have official param type string
    var isOfficial = official > 0 || isVerified;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        style: {
            cursor: "pointer"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* CommentContainer */.bQ, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex, {
                    mb: "10px",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar, {
                            size: "x-small",
                            padding: "0 10px 0 0",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                alt: "imageProfile",
                                src: avatarUrl,
                                onError: function(e) {
                                    return (0,general/* handleErrorAvatar */.Tk)(e, username);
                                }
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex, {
                                    align: "center",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: "/".concat(username),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* TextHeader */.Y, {
                                                family: "bold",
                                                size: "14px",
                                                children: username
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Labels/* LabelVerifiedAccount */.uC, {
                                            deprecatedVerifiedStatus: isOfficial,
                                            verifiedStatus: comment === null || comment === void 0 ? void 0 : comment.verified_status
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Labels/* LabelAdmin */.SH, {
                                            privilege: privilege
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* TextHeader */.Y, {
                                    size: "12px",
                                    color: ui/* color.midgray */.$_.midgray,
                                    children: created
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(TextContent/* default */.Z, {
                    content: content,
                    maskedHtml: maskedHtml,
                    style: {
                        marginBottom: "0px"
                    },
                    needParsed: false
                })
            ]
        })
    }));
}
/* harmony default export */ var Post_Comment = (Comment);

// EXTERNAL MODULE: ./src/global/StreamWidget/Post/DocumentContainer.tsx
var DocumentContainer = __webpack_require__(55424);
// EXTERNAL MODULE: ./src/global/StreamWidget/Post/Header.tsx
var Header = __webpack_require__(5373);
// EXTERNAL MODULE: ./src/global/StreamWidget/Post/PinnedLabel.tsx
var PinnedLabel = __webpack_require__(82592);
// EXTERNAL MODULE: ./src/global/StreamWidget/Post/RepostBox.tsx
var RepostBox = __webpack_require__(38294);
// EXTERNAL MODULE: ./src/global/StreamWidget/Post/TitleContent.tsx + 1 modules
var TitleContent = __webpack_require__(41447);
// EXTERNAL MODULE: ./src/global/StreamWidget/Post/YoutubePlayer.tsx
var YoutubePlayer = __webpack_require__(74132);
// EXTERNAL MODULE: ./src/global/StreamWidget/Post/Footer.tsx
var Footer = __webpack_require__(90668);
;// CONCATENATED MODULE: ./src/global/StreamWidget/Post/index.tsx
/* eslint-disable react/require-default-props */ /* eslint-disable indent */ /* eslint-disable camelcase */ 




















var Post_Flex = ui/* Common.Flex */.Gn.Flex, Text = ui/* Common.Text */.Gn.Text;
var GuestFooter = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 4597).then(__webpack_require__.bind(__webpack_require__, 4597));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(4597)
            ];
        }
    },
    ssr: false,
    loading: function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {});
    }
});
var FollowingActivity = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 1895).then(__webpack_require__.bind(__webpack_require__, 81895));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(81895)
            ];
        }
    },
    ssr: false,
    loading: function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {});
    }
});
function Post(param) {
    var post = param.post, onComment = param.onComment, _pinned = param.pinned, pinned = _pinned === void 0 ? false : _pinned, _showLatestComment = param.showLatestComment, showLatestComment = _showLatestComment === void 0 ? true : _showLatestComment, _hasFollowingActivity = param.hasFollowingActivity, hasFollowingActivity = _hasFollowingActivity === void 0 ? true : _hasFollowingActivity, _expandContent = param.expandContent, expandContent = _expandContent === void 0 ? false : _expandContent, _isFirstPost = param.isFirstPost, isFirstPost = _isFirstPost === void 0 ? false : _isFirstPost, _isSinglePost = param.isSinglePost, isSinglePost = _isSinglePost === void 0 ? false : _isSinglePost, _highlightWord = param.highlightWord, highlightWord = _highlightWord === void 0 ? "" : _highlightWord, _symbol = param.symbol, symbol = _symbol === void 0 ? "" : _symbol, entryPoint = param.entryPoint, dataCyName = param.dataCyName;
    var ref, ref1;
    var content = post.content, content_original = post.content_original, images = post.images, attachment = post.attachment, polling = post.polling, target_price = post.target_price, last_reply = post.last_reply, mask_html = post.mask_html, reposted = post.reposted, repostedfrom = post.repostedfrom, title = post.title, titleurl = post.titleurl, images_data = post.images_data, image_frame_type = post.image_frame_type, followingActivity = post.following_activity, isAuthor = post.is_author;
    var isLoggedIn = (0,es/* useSelector */.v9)(credentials/* selectors */.wl).isLoggedIn;
    var imagesData = (0,react.useMemo)(function() {
        var listImage = (images === null || images === void 0 ? void 0 : images.length) > 0 && images[0] !== "" ? images.map(function(i) {
            return {
                image: i
            };
        }) : [];
        listImage = listImage.filter(function(i) {
            var exist = images_data.find(function(img) {
                return img.image === i.image;
            });
            return !exist;
        });
        listImage = (0,_to_consumable_array/* default */.Z)(listImage).concat((0,_to_consumable_array/* default */.Z)(images_data));
        return listImage;
    }, [
        post
    ]);
    var isHaveImage = Boolean((imagesData === null || imagesData === void 0 ? void 0 : imagesData.length) > 0 && ((ref = imagesData[0]) === null || ref === void 0 ? void 0 : ref.image));
    var showFollowingActivity = (followingActivity === null || followingActivity === void 0 ? void 0 : (ref1 = followingActivity.users) === null || ref1 === void 0 ? void 0 : ref1.length) > 0 && hasFollowingActivity;
    var autoplayYoutube = !isSinglePost;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* StreamBoxContainer */.Vj, {
        "data-cy": dataCyName,
        children: [
            pinned && /*#__PURE__*/ (0,jsx_runtime.jsx)(PinnedLabel/* default */.Z, {
                isCompanyPinnedPost: entryPoint === "symbol"
            }),
            showFollowingActivity && /*#__PURE__*/ (0,jsx_runtime.jsx)(FollowingActivity, {
                data: followingActivity
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Header/* default */.Z, {
                post: post,
                isLoggedIn: isLoggedIn,
                entryPoint: entryPoint,
                symbol: symbol
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* ContentWrapper */.vs, {
                children: [
                    (polling === null || polling === void 0 ? void 0 : polling.length) && isLoggedIn > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(PollingContainer/* default */.Z, {
                        post: post,
                        isSinglePost: isSinglePost,
                        isTextDefaultExpand: expandContent,
                        highlightWord: highlightWord
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* TextContainer */.lU, {
                                children: [
                                    title && titleurl && /*#__PURE__*/ (0,jsx_runtime.jsx)(TitleContent/* default */.Z, {
                                        title: title,
                                        highlightWord: highlightWord,
                                        titleUrl: titleurl
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TextContent/* default */.Z, {
                                        content: content,
                                        maskedHtml: mask_html,
                                        isDefaultExpand: expandContent,
                                        highlightWord: highlightWord
                                    }),
                                    post.newsfeed_source && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Post_Flex, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                                alt: post.newsfeed_label,
                                                src: post.newsfeed_img,
                                                style: {
                                                    width: "16px",
                                                    marginRight: "8px"
                                                }
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text, {
                                                size: "12px",
                                                children: post.newsfeed_label
                                            })
                                        ]
                                    })
                                ]
                            }),
                            isHaveImage ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageSlider/* default */.Z, {
                                images: imagesData,
                                frameType: image_frame_type,
                                isSinglePost: isSinglePost
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(YoutubePlayer/* default */.Z, {
                                content: content_original,
                                autoplay: autoplayYoutube
                            }),
                            isLoggedIn ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    (attachment === null || attachment === void 0 ? void 0 : attachment.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(DocumentContainer/* default */.Z, {
                                        documents: attachment
                                    }),
                                    (target_price === null || target_price === void 0 ? void 0 : target_price.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(TargetPriceContainer/* default */.Z, {
                                        targetPrice: target_price[0],
                                        postid: post.postid,
                                        isAuthor: isAuthor
                                    })
                                ]
                            }) : null
                        ]
                    }),
                    reposted > 0 && isLoggedIn && /*#__PURE__*/ (0,jsx_runtime.jsx)(RepostBox/* default */.Z, {
                        post: repostedfrom
                    }),
                    isLoggedIn ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer["default"], {
                        post: post,
                        onComment: onComment,
                        isFirstPost: isFirstPost,
                        symbol: symbol
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(GuestFooter, {
                        post: post
                    })
                ]
            }),
            isLoggedIn && showLatestComment && last_reply && Object.keys(last_reply).length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Post_Comment, {
                comment: last_reply,
                onClick: onComment
            })
        ]
    });
}
/* harmony default export */ var StreamWidget_Post = (Post);


/***/ }),

/***/ 59007:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O8": function() { return /* binding */ BackTopWrapper; },
/* harmony export */   "OD": function() { return /* binding */ StreamNewPostText; },
/* harmony export */   "Vd": function() { return /* binding */ StreamWidgetBox; },
/* harmony export */   "fh": function() { return /* binding */ LineLoader; },
/* harmony export */   "kq": function() { return /* binding */ StreamNewPostBox; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(76825);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19521);
/* eslint-disable space-infix-ops */ /* eslint-disable indent */ 
function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n            max-width: 100%;\n          "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n          max-width: calc(100% - 330px);\n        "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      border: none;\n      border-radius: 4px;\n    "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  background: ",
        ";\n  border: solid 1px ",
        ";\n  border-radius: ",
        ";\n\n  &.guest-stream {\n    flex: 1;\n    max-width: 100%;\n\n    @media ",
        " {\n      ",
        "\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  background-color: ",
        ";\n  border: solid 1px ",
        ";\n  border-bottom: none;\n  cursor: pointer;\n  border-radius: 3px 3px 0 0;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  color: ",
        ";\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  background: #a2a7b0; // this is intentionally hardcoded\n  border-radius: 50%;\n  bottom: 25px;\n  color: ",
        ";\n  right: 60px;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  from {\n    left: -200px;\n    width: 30%;\n  }\n  50% {\n    width: 30%;\n  }\n  70% {\n    width: 70%;\n  }\n  80% {\n    left: 50%;\n  }\n  95% {\n    left: 120%;\n  }\n  to {\n    left: 100%;\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: block;\n  height: 1px;\n  width: 100%;\n  position: relative;\n  overflow: hidden;\n  background-color: #dadada;\n  display: ",
        ";\n\n  :before {\n    position: absolute;\n    content: '';\n    left: -200px;\n    width: 200px;\n    height: 1px;\n    background-color: #00ab6b;\n    animation: ",
        " 2s linear infinite;\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}


var Flex = _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .Common.Flex */ .Gn.Flex, Text = _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .Common.Text */ .Gn.Text;
var StreamWidgetBox = styled_components__WEBPACK_IMPORTED_MODULE_2__["default"].div.withConfig({
    componentId: "sc-2f1ceddb-0"
})(_templateObject3(), _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.light */ .$_.light, _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.gainsboro */ .$_.gainsboro, function(param) {
    var newPostCount = param.newPostCount;
    return newPostCount > 2 ? "0" : "3px";
}, _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .device.tablet */ .Uh.tablet, function(param) {
    var isCompanyStock = param.isCompanyStock;
    if (isCompanyStock) {
        return (0,styled_components__WEBPACK_IMPORTED_MODULE_2__.css)(_templateObject());
    }
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_2__.css)(_templateObject1());
}, function(param) {
    var noBorder = param.noBorder;
    return noBorder && (0,styled_components__WEBPACK_IMPORTED_MODULE_2__.css)(_templateObject2());
});
var StreamNewPostBox = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__["default"])(Flex).attrs({
    justify: "center",
    align: "center",
    py: "7px",
    // accessibility props
    role: "button"
}).withConfig({
    componentId: "sc-2f1ceddb-1"
})(_templateObject4(), _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.light */ .$_.light, _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.gainsboro */ .$_.gainsboro);
var StreamNewPostText = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__["default"])(Text).withConfig({
    componentId: "sc-2f1ceddb-2"
})(_templateObject5(), _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.primary */ .$_.primary);
var BackTopWrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__["default"])(Flex).attrs({
    align: "center",
    height: "40px",
    justify: "center",
    width: "40px"
}).withConfig({
    componentId: "sc-2f1ceddb-3"
})(_templateObject6(), _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.light */ .$_.light);
var LineAnimation = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__.keyframes)(_templateObject7());
var LineLoader = styled_components__WEBPACK_IMPORTED_MODULE_2__["default"].div.withConfig({
    componentId: "sc-2f1ceddb-4"
})(_templateObject8(), function(param) {
    var isLoading = param.isLoading;
    return isLoading ? "block" : "none";
}, LineAnimation);



/***/ }),

/***/ 75218:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
module.exports = new Promise(function (resolve, reject) {
    var url = new URL("https://storage.stockbit.com/fast-trade/1.1.1/static/remoteEntry.js");
    url.searchParams.set('t', Date.now());
    var __webpack_error__ = new Error();
    if(!window.remoteLoading) {
        window.remoteLoading = {};
    };

    if(window.remoteLoading["fasttrade"]) {
      return resolve(window.remoteLoading["fasttrade"])
    }

    var res, rej;
    window.remoteLoading["fasttrade"] = new Promise(function(rs,rj){
      res = rs;
      rej = rj;
    })

    if (typeof window["fasttrade"] !== 'undefined') {
      res(window["fasttrade"]);
      return resolve(window["fasttrade"]);
    }

     __webpack_require__.l(
      url.href,
      function (event) {
        if (typeof window["fasttrade"] !== 'undefined') {
          res(window["fasttrade"]);
          return resolve(window["fasttrade"]);
        }
        var errorType = event && (event.type === 'load' ? 'missing' : event.type);
        var realSrc = event && event.target && event.target.src;
        __webpack_error__.message =
          'Loading script failed.\n(' + errorType + ': ' + realSrc + ')';
        __webpack_error__.name = 'ScriptExternalLoadError';
        __webpack_error__.type = errorType;
        __webpack_error__.request = realSrc;
        rej(__webpack_error__);
        reject(__webpack_error__);
      },
      "fasttrade"
    );
  }).then(function () {
    const proxy = {
      get: fasttrade.get,
      init: function(shareScope, initToken) {

        const handler = {
          get(target, prop) {
            if (target[prop]) {
              Object.values(target[prop]).forEach(function(o) {
                if(o.from === '_N_E') {
                  o.loaded = 1
                }
              })
            }
            return target[prop]
          },
          set(target, property, value, receiver) {
            if (target[property]) {
              return target[property]
            }
            target[property] = value
            return true
          }
        }
        try {
          fasttrade.init(new Proxy(shareScope, handler), initToken)
        } catch (e) {

        }
        fasttrade.__initialized = true
      }
    }
    if (!fasttrade.__initialized) {
      proxy.init(__webpack_require__.S.default)
    }
    return proxy
  });

/***/ }),

/***/ 74271:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
module.exports = new Promise(function (resolve, reject) {
    var url = new URL("https://storage.stockbit.com/movers/1.0.1/static/remoteEntry.js");
    url.searchParams.set('t', Date.now());
    var __webpack_error__ = new Error();
    if(!window.remoteLoading) {
        window.remoteLoading = {};
    };

    if(window.remoteLoading["movers"]) {
      return resolve(window.remoteLoading["movers"])
    }

    var res, rej;
    window.remoteLoading["movers"] = new Promise(function(rs,rj){
      res = rs;
      rej = rj;
    })

    if (typeof window["movers"] !== 'undefined') {
      res(window["movers"]);
      return resolve(window["movers"]);
    }

     __webpack_require__.l(
      url.href,
      function (event) {
        if (typeof window["movers"] !== 'undefined') {
          res(window["movers"]);
          return resolve(window["movers"]);
        }
        var errorType = event && (event.type === 'load' ? 'missing' : event.type);
        var realSrc = event && event.target && event.target.src;
        __webpack_error__.message =
          'Loading script failed.\n(' + errorType + ': ' + realSrc + ')';
        __webpack_error__.name = 'ScriptExternalLoadError';
        __webpack_error__.type = errorType;
        __webpack_error__.request = realSrc;
        rej(__webpack_error__);
        reject(__webpack_error__);
      },
      "movers"
    );
  }).then(function () {
    const proxy = {
      get: movers.get,
      init: function(shareScope, initToken) {

        const handler = {
          get(target, prop) {
            if (target[prop]) {
              Object.values(target[prop]).forEach(function(o) {
                if(o.from === '_N_E') {
                  o.loaded = 1
                }
              })
            }
            return target[prop]
          },
          set(target, property, value, receiver) {
            if (target[property]) {
              return target[property]
            }
            target[property] = value
            return true
          }
        }
        try {
          movers.init(new Proxy(shareScope, handler), initToken)
        } catch (e) {

        }
        movers.__initialized = true
      }
    }
    if (!movers.__initialized) {
      proxy.init(__webpack_require__.S.default)
    }
    return proxy
  });

/***/ }),

/***/ 53166:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
module.exports = new Promise(function (resolve, reject) {
    var url = new URL("https://storage.stockbit.com/tradebook-chart/1.0.0/static/remoteEntry.js");
    url.searchParams.set('t', Date.now());
    var __webpack_error__ = new Error();
    if(!window.remoteLoading) {
        window.remoteLoading = {};
    };

    if(window.remoteLoading["tradebookchart"]) {
      return resolve(window.remoteLoading["tradebookchart"])
    }

    var res, rej;
    window.remoteLoading["tradebookchart"] = new Promise(function(rs,rj){
      res = rs;
      rej = rj;
    })

    if (typeof window["tradebookchart"] !== 'undefined') {
      res(window["tradebookchart"]);
      return resolve(window["tradebookchart"]);
    }

     __webpack_require__.l(
      url.href,
      function (event) {
        if (typeof window["tradebookchart"] !== 'undefined') {
          res(window["tradebookchart"]);
          return resolve(window["tradebookchart"]);
        }
        var errorType = event && (event.type === 'load' ? 'missing' : event.type);
        var realSrc = event && event.target && event.target.src;
        __webpack_error__.message =
          'Loading script failed.\n(' + errorType + ': ' + realSrc + ')';
        __webpack_error__.name = 'ScriptExternalLoadError';
        __webpack_error__.type = errorType;
        __webpack_error__.request = realSrc;
        rej(__webpack_error__);
        reject(__webpack_error__);
      },
      "tradebookchart"
    );
  }).then(function () {
    const proxy = {
      get: tradebookchart.get,
      init: function(shareScope, initToken) {

        const handler = {
          get(target, prop) {
            if (target[prop]) {
              Object.values(target[prop]).forEach(function(o) {
                if(o.from === '_N_E') {
                  o.loaded = 1
                }
              })
            }
            return target[prop]
          },
          set(target, property, value, receiver) {
            if (target[property]) {
              return target[property]
            }
            target[property] = value
            return true
          }
        }
        try {
          tradebookchart.init(new Proxy(shareScope, handler), initToken)
        } catch (e) {

        }
        tradebookchart.__initialized = true
      }
    }
    if (!tradebookchart.__initialized) {
      proxy.init(__webpack_require__.S.default)
    }
    return proxy
  });

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3798,2678,4885,296,7570,7148,9521,9586,9459,6819,2987,5872,129,1107,1605,6395,1577,5436,2077,4268,6750,2700,7121,7505,3176,1980,430,8657,7081,7713,4114,5106,1977,7016,4158,5717,7440,9720,5616,6041,1232,1066,9181,3930,2753,7292,9774,2888,179], function() { return __webpack_exec__(64677); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);